import Vue from 'vue'
import Qs from 'qs'
import md5 from 'js-md5'
import router from '../router'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

const LocalFingerprint = ""

// API
// const Url_Base = "http://212.64.26.10:8686/ErpApi/"
const Url_Base = "https://apirsl.eyesreal.com:8686/ErpApi/"
const Url_ErpLogin = Url_Base + "ErpLogin"
const Url_CheckLogin = Url_Base + "CheckLogin"
const Url_Addmenu = Url_Base + "Addmenu"
const Url_Getallmenu = Url_Base + "Getallmenu"
const Url_Getonemenu = Url_Base + "Getonemenu"
const Url_Editonemenu = Url_Base + "Editonemenu"
const Url_Deleteonemenu = Url_Base + "Deleteonemenu"
const Url_Addrole = Url_Base + "Addrole"
const Url_Getallrole = Url_Base + "Getallrole"
const Url_Editonerole = Url_Base + "Editonerole"
const Url_Getrolepermissions = Url_Base + "Getrolepermissions"
const Url_Editrolepermissions = Url_Base + "Editrolepermissions"
const Url_Deleteonerole = Url_Base + "Deleteonerole"
const Url_Getjigoutree = Url_Base + "Getjigoutree"
const Url_Getjigoulist = Url_Base + "Getjigoulist"
const Url_Getjigoutreesmall = Url_Base + "Getjigoutreesmall"
const Url_Getjigoutreeid = Url_Base + "Getjigoutreeid"
const Url_Getregionlist = Url_Base + "Getregionlist"
const Url_Addjigou = Url_Base + "Addjigou"
const Url_Editjigou = Url_Base + "Editjigou"
const Url_Deletejigou = Url_Base + "Deletejigou"
const Url_Deletejigouforce = Url_Base + "Deletejigouforce"
const Url_Geterpusernum = Url_Base + "Geterpusernum"
const Url_Geterpuserlist = Url_Base + "Geterpuserlist"
const Url_Adderpuser = Url_Base + "Adderpuser"
const Url_Editerpuser = Url_Base + "Editerpuser"
const Url_Editerpuserstaus = Url_Base + "Editerpuserstaus"
const Url_Deleteerpuser = Url_Base + "Deleteerpuser"
const Url_Getspeedlist = Url_Base + "Getspeedlist"
const Url_Editspeed = Url_Base + "Editspeed"
const Url_Getloglist = Url_Base + "Getloglist"
const Url_Getlognum = Url_Base + "Getlognum"
const Url_GetlogTongJi = Url_Base + "GetlogTongJi"
const Url_Getfaceidloglist = Url_Base + "Getfaceidloglist"
const Url_Getfaceidlognum = Url_Base + "Getfaceidlognum"
const Url_Getversionlist = Url_Base + "Getversionlist"
const Url_Addversion = Url_Base + "Addversion"
const Url_Editversion = Url_Base + "Editversion"
const Url_Deleteversion = Url_Base + "Deleteversion"
const Url_Getprivatemenu = Url_Base + "Getprivatemenu"
const Url_Editselfpwd = Url_Base + "Editselfpwd"
const Url_GetTencentyunCosSts = Url_Base + "GetTencentyunCosSts"
const Url_Erpapidefault = Url_Base + "Erpapidefault"
const Url_GetDlsOrderSubWithOrderid = Url_Base + "GetDlsOrderSubWithOrderid"
const Url_GetDlsOrderInfoWithOrderid = Url_Base + "GetDlsOrderInfoWithOrderid"
const Url_Editproductinfo = Url_Base + "Editproductinfo"
const Url_Deleteproductinfo = Url_Base + "Deleteproductinfo"
const Url_Addproductmoney = Url_Base + "Addproductmoney"
const Url_Getallproductmoneylist = Url_Base + "Getallproductmoneylist"
const Url_Getallproductmoneynum = Url_Base + "Getallproductmoneynum"
const Url_Editproductmoney = Url_Base + "Editproductmoney"
const Url_Editproductmoneyshenhe = Url_Base + "Editproductmoneyshenhe"
const Url_Deleteproductmoney = Url_Base + "Deleteproductmoney"
const Url_Getproductjiage = Url_Base + "Getproductjiage"
const Url_Addproductorder = Url_Base + "Addproductorder"
const Url_Addproductorderbeizhu = Url_Base + "Addproductorderbeizhu"
const Url_Addproductorderinvoice = Url_Base + "Addproductorderinvoice"
const Url_Editproductorder = Url_Base + "Editproductorder"
const Url_GenerateFuOrder = Url_Base + "GenerateFuOrder"
const Url_Geterporderlist = Url_Base + "Geterporderlist"
const Url_Geterporderlistsub = Url_Base + "Geterporderlistsub"
const Url_DeleteErpOrder = Url_Base + "DeleteErpOrder"
const Url_DeleteErpOrderInvoice = Url_Base + "DeleteErpOrderInvoice"
const Url_Geterpordernum = Url_Base + "Geterpordernum"
const Url_Geterporderinvoicelist = Url_Base + "Geterporderinvoicelist"
const Url_Geterporderbeizhulist = Url_Base + "Geterporderbeizhulist"
const Url_Editerporderpayimage = Url_Base + "Editerporderpayimage"
const Url_Editerpordercaiwushenhe = Url_Base + "Editerpordercaiwushenhe"
const Url_Editerpordercaiwuqishen = Url_Base + "Editerpordercaiwuqishen"
const Url_Editerporderinvoicestatus = Url_Base + "Editerporderinvoicestatus"
const Url_Editerpordersubinvoicestatus = Url_Base + "Editerpordersubinvoicestatus"
const Url_Editerporderwuliu = Url_Base + "Editerporderwuliu"
const Url_Editerporderreceipt = Url_Base + "Editerporderreceipt"
const Url_Editerporderreceiptsimage = Url_Base + "Editerporderreceiptsimage"
const Url_GetSubRuleStaus = Url_Base + "GetSubRuleStaus"
const Url_Addproductsales = Url_Base + "Addproductsales"
const Url_Getproductsalesnum = Url_Base + "Getproductsalesnum"
const Url_Getproductsaleslist = Url_Base + "Getproductsaleslist"
const Url_Editproductsales = Url_Base + "Editproductsales"
const Url_Addmadeorder = Url_Base + "Addmadeorder"
const Url_Getmadeordernum = Url_Base + "Getmadeordernum"
const Url_Getmadeorderlist = Url_Base + "Getmadeorderlist"
const Url_Getmadeordernumkucun = Url_Base + "Getmadeordernumkucun"
const Url_Getmadeorderlistkucun = Url_Base + "Getmadeorderlistkucun"
const Url_Editmadeordershenhe = Url_Base + "Editmadeordershenhe"
const Url_Editmadeordercancel = Url_Base + "Editmadeordercancel"
const Url_Editmadeorderdelay = Url_Base + "Editmadeorderdelay"
const Url_Editmadeordertargetnum = Url_Base + "Editmadeordertargetnum"
const Url_Editmadeordersubmitnum = Url_Base + "Editmadeordersubmitnum"
const Url_AddDlsReturnsHuan = Url_Base + "AddDlsReturnsHuan"
const Url_GetDlsReturnsHuannum = Url_Base + "GetDlsReturnsHuannum"
const Url_GetDlsReturnsHuanlist = Url_Base + "GetDlsReturnsHuanlist"
const Url_EditDlsReturnsHuanshenhe = Url_Base + "EditDlsReturnsHuanshenhe"
const Url_EditDlsReturnsHuanSend = Url_Base + "EditDlsReturnsHuanSend"
const Url_EditDlsReturnsHuanSendOk = Url_Base + "EditDlsReturnsHuanSendOk"
const Url_EditDlsReturnsHuanReSend = Url_Base + "EditDlsReturnsHuanReSend"
const Url_EditDlsReturnsHuanReSendOk = Url_Base + "EditDlsReturnsHuanReSendOk"
const Url_AddDlsReturnsTui = Url_Base + "AddDlsReturnsTui"
const Url_GetDlsReturnsTuinum = Url_Base + "GetDlsReturnsTuinum"
const Url_GetDlsReturnsTuilist = Url_Base + "GetDlsReturnsTuilist"
const Url_EditDlsReturnsTuishenhe = Url_Base + "EditDlsReturnsTuishenhe"
const Url_EditDlsReturnsTuiSend = Url_Base + "EditDlsReturnsTuiSend"
const Url_EditDlsReturnsTuiSendOk = Url_Base + "EditDlsReturnsTuiSendOk"
const Url_Getproductinventorylist = Url_Base + "Getproductinventorylist"
const Url_Getproductinventorynum = Url_Base + "Getproductinventorynum"
const Url_Getallfinishedproductinventory = Url_Base + "Getallfinishedproductinventory"
const Url_Getcustomerlist = Url_Base + "Getcustomerlist"
const Url_Getcustomernum = Url_Base + "Getcustomernum"
const Url_CheckCardnumber = Url_Base + "CheckCardnumber"
const Url_CheckCardnumberJigou = Url_Base + "CheckCardnumberJigou"
const Url_Getpincode = Url_Base + "Getpincode"
const Url_Addcustomer = Url_Base + "Addcustomer"
const Url_Getcustomerexcel = Url_Base + "Getcustomerexcel"
const Url_Geterpfilenum = Url_Base + "Geterpfilenum"
const Url_Geterpfilelist = Url_Base + "Geterpfilelist"
const Url_Geterpimagenum = Url_Base + "Geterpimagenum"
const Url_DelErpImage = Url_Base + "DelErpImage"
const Url_Geterpimagelist = Url_Base + "Geterpimagelist"
const Url_GetRegisterEyeinfo = Url_Base + "GetRegisterEyeinfo"
const Url_EditRegisterEyeinfo = Url_Base + "EditRegisterEyeinfo"
const Url_Getcustomerinfo = Url_Base + "Getcustomerinfo"
const Url_Editcustomeravatarurl = Url_Base + "Editcustomeravatarurl"
const Url_Editcustomerbind = Url_Base + "Editcustomerbind"
const Url_Editcustomerunbind = Url_Base + "Editcustomerunbind"
const Url_Editcustomerdelay = Url_Base + "Editcustomerdelay"
const Url_Getcustomereditinfo = Url_Base + "Getcustomereditinfo"
const Url_Getglassuserchangeiplimit = Url_Base + "Getglassuserchangeiplimit"
const Url_Editcustomereditinfo = Url_Base + "Editcustomereditinfo"
const Url_EditCustomerLoginName = Url_Base + "EditCustomerLoginName"
const Url_Getfuchalist = Url_Base + "Getfuchalist"
const Url_Getfuchanum = Url_Base + "Getfuchanum"
const Url_Addfucha = Url_Base + "Addfucha"
const Url_Editfucha = Url_Base + "Editfucha"
const Url_Getfuchalist2 = Url_Base + "Getfuchalist2"
const Url_Getcustomerpause = Url_Base + "Getcustomerpause"
const Url_Getcustomerchangeuserlogin = Url_Base + "Getcustomerchangeuserlogin"
const Url_Addcustomerpause = Url_Base + "Addcustomerpause"
const Url_Forcedeletecustomer = Url_Base + "Forcedeletecustomer"
const Url_Getcustomeriplist = Url_Base + "Getcustomeriplist"
const Url_Getcustomeripnum = Url_Base + "Getcustomeripnum"
const Url_Getrenewallist = Url_Base + "Getrenewallist"
const Url_Getrenewalnum = Url_Base + "Getrenewalnum"
const Url_Getrenewaltyjlist = Url_Base + "Getrenewaltyjlist"
const Url_Getrenewaltyjnum = Url_Base + "Getrenewaltyjnum"
const Url_Addrenewalorder = Url_Base + "Addrenewalorder"
const Url_Getcustomerlist2 = Url_Base + "Getcustomerlist2"
const Url_Getcustomernum2 = Url_Base + "Getcustomernum2"
const Url_Getcustomerlist3 = Url_Base + "Getcustomerlist3"
const Url_Getcustomernum3 = Url_Base + "Getcustomernum3"
const Url_Getcustomerruledata = Url_Base + "Getcustomerruledata"
const Url_Editcustomerruledata = Url_Base + "Editcustomerruledata"
const Url_GetDownDatalist = Url_Base + "GetDownDatalist"
const Url_GetDownDatanum = Url_Base + "GetDownDatanum"
const Url_GetCaijilist = Url_Base + "GetCaijilist"
const Url_GetCaijinum = Url_Base + "GetCaijinum"
const Url_GetSensorDatalist = Url_Base + "GetSensorDatalist"
const Url_GetSensorDatanum = Url_Base + "GetSensorDatanum"
const Url_GetDevicelist = Url_Base + "GetDevicelist"
const Url_GetDevicePlLianglist = Url_Base + "GetDevicePlLianglist"
const Url_GetDevicePlLiangnum = Url_Base + "GetDevicePlLiangnum"
const Url_ProcessDevicePlLiang = Url_Base + "ProcessDevicePlLiang"
const Url_GetDeviceSaleStatistical = Url_Base + "GetDeviceSaleStatistical"
const Url_GetDevicenum = Url_Base + "GetDevicenum"
const Url_AddDevice = Url_Base + "AddDevice"
const Url_AddDevicePlLiang = Url_Base + "AddDevicePlLiang"
const Url_EditDevice = Url_Base + "EditDevice"
const Url_EditDeviceUnbind = Url_Base + "EditDeviceUnbind"
const Url_EditDeviceJigou = Url_Base + "EditDeviceJigou"
const Url_EditDeviceJigouPlLiang = Url_Base + "EditDeviceJigouPlLiang"
const Url_GetDeviceinfo = Url_Base + "GetDeviceinfo"
const Url_GetDevicepause = Url_Base + "GetDevicepause"
const Url_AddDevicepause = Url_Base + "AddDevicepause"
const Url_ForceClearDevice = Url_Base + "ForceClearDevice"
const Url_GetDeviceMovelist = Url_Base + "GetDeviceMovelist"
const Url_GetDeviceMovenum = Url_Base + "GetDeviceMovenum"
const Url_GetChangeTypelist = Url_Base + "GetChangeTypelist"
const Url_GetChangeTypenum = Url_Base + "GetChangeTypenum"
const Url_GetDailyDatalist = Url_Base + "GetDailyDatalist"
const Url_GetDailyDatanum = Url_Base + "GetDailyDatanum"
const Url_GetGanyuHeJujian = Url_Base + "GetGanyuHeJujian"
const Url_GetCaiJiTrend = Url_Base + "GetCaiJiTrend"
const Url_AnnualReportlist = Url_Base + "AnnualReportlist"
const Url_AnnualReportnum = Url_Base + "AnnualReportnum"
const Url_GetAnnualReportinfo = Url_Base + "GetAnnualReportinfo"
const Url_WearingDayslist = Url_Base + "WearingDayslist"
const Url_WearingDaysnum = Url_Base + "WearingDaysnum"
const Url_Feedbacklist = Url_Base + "Feedbacklist"
const Url_Feedbacknum = Url_Base + "Feedbacknum"
const Url_EditFeedback = Url_Base + "EditFeedback"
const Url_Qalist = Url_Base + "Qalist"
const Url_Qanum = Url_Base + "Qanum"
const Url_AddQa = Url_Base + "AddQa"
const Url_EditQa = Url_Base + "EditQa"
const Url_Caseslist = Url_Base + "Caseslist"
const Url_Casesnum = Url_Base + "Casesnum"
const Url_AddCases = Url_Base + "AddCases"
const Url_EditCases = Url_Base + "EditCases"
const Url_DeleteCases = Url_Base + "DeleteCases"
const Url_OptometryHalllist = Url_Base + "OptometryHalllist"
const Url_OptometryHallnum = Url_Base + "OptometryHallnum"
const Url_AddOptometryHall = Url_Base + "AddOptometryHall"
const Url_EditOptometryHall = Url_Base + "EditOptometryHall"
const Url_DeleteOptometryHall = Url_Base + "DeleteOptometryHall"
const Url_Newslist = Url_Base + "Newslist"
const Url_Newsnum = Url_Base + "Newsnum"
const Url_AddNews = Url_Base + "AddNews"
const Url_EditNews = Url_Base + "EditNews"
const Url_DeleteNews = Url_Base + "DeleteNews"
const Url_GetHomePageData = Url_Base + "GetHomePageData"
const Url_ExceptionReminderlist = Url_Base + "ExceptionReminderlist"
const Url_ExceptionRemindernum = Url_Base + "ExceptionRemindernum"
const Url_ImportantReminderlist = Url_Base + "ImportantReminderlist"
const Url_ImportantRemindernum = Url_Base + "ImportantRemindernum"
const Url_ReviewReminderlist = Url_Base + "ReviewReminderlist"
const Url_ReviewRemindernum = Url_Base + "ReviewRemindernum"
const Url_LastIntervalReminderlist = Url_Base + "LastIntervalReminderlist"
const Url_LastIntervalRemindernum = Url_Base + "LastIntervalRemindernum"
const Url_DeviceExceptionReminderlist = Url_Base + "DeviceExceptionReminderlist"
const Url_DeviceExceptionRemindernum = Url_Base + "DeviceExceptionRemindernum"
const Url_GetDeviceExceptionReminderProcess = Url_Base + "GetDeviceExceptionReminderProcess"
const Url_AddDeviceExceptionReminderProcess = Url_Base + "AddDeviceExceptionReminderProcess"
const Url_CustomerRenewalOrderlist = Url_Base + "CustomerRenewalOrderlist"
const Url_CustomerRenewalOrdernum = Url_Base + "CustomerRenewalOrdernum"
const Url_EditCustomerRenewalOrder = Url_Base + "EditCustomerRenewalOrder"
const Url_CustomerRenewalOrderReport = Url_Base + "CustomerRenewalOrderReport"
const Url_StoreOwnerlist = Url_Base + "StoreOwnerlist"
const Url_StoreOwnernum = Url_Base + "StoreOwnernum"
const Url_AddStoreOwner = Url_Base + "AddStoreOwner"
const Url_EditStoreOwner = Url_Base + "EditStoreOwner"
const Url_StoreOwnerShareList = Url_Base + "StoreOwnerShareList"
const Url_StoreOwnerShareNum = Url_Base + "StoreOwnerShareNum"
const Url_StoreOwnerTransferList = Url_Base + "StoreOwnerTransferList"
const Url_StoreOwnerTransferNum = Url_Base + "StoreOwnerTransferNum"
const Url_WithdrawalApprovallist = Url_Base + "WithdrawalApprovallist"
const Url_WithdrawalApprovalnum = Url_Base + "WithdrawalApprovalnum"
const Url_WithdrawalApprovalApplyOk = Url_Base + "WithdrawalApprovalApplyOk"
const Url_WithdrawalApprovalApplyFail = Url_Base + "WithdrawalApprovalApplyFail"
const Url_WithdrawalApprovalTransfer1 = Url_Base + "WithdrawalApprovalTransfer1"
const Url_WithdrawalApprovalTransfer2 = Url_Base + "WithdrawalApprovalTransfer2"
const Url_AddDlsReturnsXiu = Url_Base + "AddDlsReturnsXiu"
const Url_GetDlsReturnsXiunum = Url_Base + "GetDlsReturnsXiunum"
const Url_GetDlsReturnsXiulist = Url_Base + "GetDlsReturnsXiulist"
const Url_EditDlsReturnsXiushenhe = Url_Base + "EditDlsReturnsXiushenhe"
const Url_EditDlsReturnsXiuSend = Url_Base + "EditDlsReturnsXiuSend"
const Url_EditDlsReturnsXiuSendOk = Url_Base + "EditDlsReturnsXiuSendOk"
const Url_EditDlsReturnsXiuReSend = Url_Base + "EditDlsReturnsXiuReSend"
const Url_EditDlsReturnsXiuReSendOk = Url_Base + "EditDlsReturnsXiuReSendOk"
const Url_ExcelExceptionReminder = Url_Base + "ExcelExceptionReminder"
const Url_ExcelImportantReminder = Url_Base + "ExcelImportantReminder"
const Url_ExcelFuCha = Url_Base + "ExcelFuCha"
const Url_ExcelRenewal = Url_Base + "ExcelRenewal"
const Url_ExcelCaiji = Url_Base + "ExcelCaiji"
const Url_ExcelCaijiCompression = Url_Base + "ExcelCaijiCompression"
const Url_ExcelDevice = Url_Base + "ExcelDevice"
const Url_ExcelErp6ProjectName = Url_Base + "ExcelErp6ProjectName"
const Url_ExcelErp6Bom = Url_Base + "ExcelErp6Bom"
const Url_ExcelErp6SupplierProfile = Url_Base + "ExcelErp6SupplierProfile"
const Url_ExcelErp6SaleBaseProductPrice = Url_Base + "ExcelErp6SaleBaseProductPrice"
const Url_ExcelErp6SaleBaseSalesTeam = Url_Base + "ExcelErp6SaleBaseSalesTeam"
const Url_ExcelErp6SaleBaseSalesperson = Url_Base + "ExcelErp6SaleBaseSalesperson"
const Url_ExcelErp6SaleBaseCustomerInfo = Url_Base + "ExcelErp6SaleBaseCustomerInfo"
const Url_ExcelErp6SaleShip = Url_Base + "ExcelErp6SaleShip"
const Url_ExcelErp6Sn = Url_Base + "ExcelErp6Sn"
const Url_ExcelErp6InventoryIn = Url_Base + "ExcelErp6InventoryIn"
const Url_ExcelErp6InventoryOut = Url_Base + "ExcelErp6InventoryOut"
const Url_ExcelRuiXiaoDiTuiPromoters = Url_Base + "ExcelRuiXiaoDiTuiPromoters"
const Url_ExcelDailyDetails = Url_Base + "ExcelDailyDetails"
const Url_ExcelDaily = Url_Base + "ExcelDaily"
const Url_ExcelRuischoolscUser = Url_Base + "ExcelRuischoolscUser"
const Url_ExcelErpDlsOrder = Url_Base + "ExcelErpDlsOrder"
const Url_ExcelNaoxjStockSendDetial = Url_Base + "ExcelNaoxjStockSendDetial"
const Url_ExcelLogsTongJi = Url_Base + "ExcelLogsTongJi"
const Url_ExcelMenDianPurchaseSalesKuCun = Url_Base + "ExcelMenDianPurchaseSalesKuCun"
const Url_ExcelMenDianPurchaseSalesCaiGouHuiZong = Url_Base + "ExcelMenDianPurchaseSalesCaiGouHuiZong"
const Url_ExcelMenDianPurchaseSalesXiaoShouHuiZong = Url_Base + "ExcelMenDianPurchaseSalesXiaoShouHuiZong"
const Url_ExcelMenDianPurchaseSalesXiaoShouMingXi = Url_Base + "ExcelMenDianPurchaseSalesXiaoShouMingXi"
const Url_ExcelNaoxjStockSale = Url_Base + "ExcelNaoxjStockSale"
const Url_ExcelNaoxjStockStock = Url_Base + "ExcelNaoxjStockStock"
const Url_ExcelAnnualReport = Url_Base + "ExcelAnnualReport"
const Url_ExcelWearingDays = Url_Base + "ExcelWearingDays"
const Url_ExcelImport = Url_Base + "ExcelImport"
const Url_ExcelImportDevice = Url_Base + "ExcelImportDevice"
const Url_ExcelImportPersonpayroll = Url_Base + "ExcelImportPersonpayroll"
const Url_ExcelImportProjectbom = Url_Base + "ExcelImportProjectbom"
const Url_ExcelImportProductMoneyRd = Url_Base + "ExcelImportProductMoneyRd"
const Url_ExcelImportRuischoolscUser = Url_Base + "ExcelImportRuischoolscUser"
const Url_ExcelImportErp6Bom = Url_Base + "ExcelImportErp6Bom"
const Url_ExcelImportErp6ProjectName = Url_Base + "ExcelImportErp6ProjectName"
const Url_ExcelImportMenDianPurchaseSalesJinXiao = Url_Base + "ExcelImportMenDianPurchaseSalesJinXiao"
const Url_ExcelImportErp6SupplierProfile = Url_Base + "ExcelImportErp6SupplierProfile"
const Url_ExcelImportErp6SaleBaseProductPrice = Url_Base + "ExcelImportErp6SaleBaseProductPrice"
const Url_ExcelImportErp6SaleBaseSalesTeam = Url_Base + "ExcelImportErp6SaleBaseSalesTeam"
const Url_ExcelImportErp6SaleBaseSalesperson = Url_Base + "ExcelImportErp6SaleBaseSalesperson"
const Url_ExcelImportErp6SaleBaseCustomerInfo = Url_Base + "ExcelImportErp6SaleBaseCustomerInfo"
const Url_ExcelImportErp6SaleShip = Url_Base + "ExcelImportErp6SaleShip"
const Url_ExcelImportErp6Sn = Url_Base + "ExcelImportErp6Sn"
const Url_ExcelOptometristPrescriptions = Url_Base + "ExcelOptometristPrescriptions"
const Url_ExcelOptometristPrescriptionsList = Url_Base + "ExcelOptometristPrescriptionsList"
const Url_ExcelOptometristJinHuoXinXi = Url_Base + "ExcelOptometristJinHuoXinXi"
const Url_ExcelSingleDiopter = Url_Base + "ExcelSingleDiopter"
const Url_ExcelDeviceSaleStatistical = Url_Base + "ExcelDeviceSaleStatistical"
const Url_ExcelProjectbom = Url_Base + "ExcelProjectbom"
const Url_ExcelProductMoneySupplier = Url_Base + "ExcelProductMoneySupplier"
const Url_ExcelOptometristInventory = Url_Base + "ExcelOptometristInventory"
const Url_ExcelYanYunDongOrderProduct = Url_Base + "ExcelYanYunDongOrderProduct"
const Url_ExcelRuiShiLiGouWuOrderProduct = Url_Base + "ExcelRuiShiLiGouWuOrderProduct"
const Url_ExcelErpDlsLogErpLogin = Url_Base + "ExcelErpDlsLogErpLogin"
const Url_ExcelYingTongDevice = Url_Base + "ExcelYingTongDevice"
const Url_ZipFileRuischoolscUser = Url_Base + "ZipFileRuischoolscUser"
const Url_Getweixiutype = Url_Base + "Getweixiutype"
const Url_GetYunYingShangKuCun = Url_Base + "GetYunYingShangKuCun"
const Url_GetYunYingShangSalesDetail = Url_Base + "GetYunYingShangSalesDetail"
const Url_GetYunYingShangSalesDetailExcel = Url_Base + "GetYunYingShangSalesDetailExcel"
const Url_GetPaymentAccount = Url_Base + "GetPaymentAccount"
const Url_ListBomsn = Url_Base + "ListBomsn"
//ERP2
const Url_AddCaiWuReport = Url_Base + "AddCaiWuReport"
const Url_EditCaiWuReport = Url_Base + "EditCaiWuReport"
const Url_GetCaiWuReportList = Url_Base + "GetCaiWuReportList"
const Url_GetCaiWuReportNum = Url_Base + "GetCaiWuReportNum"
//审批费用报销&差旅费报销&采购付款
const Url_AddShenPiNewFyBxChaiLv1 = Url_Base + "AddShenPiNewFyBxChaiLv1"
const Url_AddShenPiNewFyBxChaiLv2 = Url_Base + "AddShenPiNewFyBxChaiLv2"
const Url_AddShenPiNewFyBxChaiLv3 = Url_Base + "AddShenPiNewFyBxChaiLv3"
const Url_AddShenPiNewFyBxChaiLv4 = Url_Base + "AddShenPiNewFyBxChaiLv4"
const Url_CheckCaiGouOrderid = Url_Base + "CheckCaiGouOrderid"
const Url_DelShenPiNewFyBxChaiLv  = Url_Base + "DelShenPiNewFyBxChaiLv"
const Url_EditShenPiNewFyBxChaiLv1  = Url_Base + "EditShenPiNewFyBxChaiLv1"
const Url_EditShenPiNewFyBxChaiLv2  = Url_Base + "EditShenPiNewFyBxChaiLv2"
const Url_EditShenPiNewFyBxChaiLv3  = Url_Base + "EditShenPiNewFyBxChaiLv3"
const Url_EditShenPiNewFyBxChaiLv4  = Url_Base + "EditShenPiNewFyBxChaiLv4"
const Url_GetShenPiNewFyBxChaiLvList     = Url_Base + "GetShenPiNewFyBxChaiLvList"
const Url_GetShenPiNewFyBxChaiLvLogList     = Url_Base + "GetShenPiNewFyBxChaiLvLogList"
const Url_GetShenPiNewFyBxChaiLvNum     = Url_Base + "GetShenPiNewFyBxChaiLvNum"
const Url_GetShenPiNewFyBxChaiLvSubList     = Url_Base + "GetShenPiNewFyBxChaiLvSubList"
const Url_ShenPiNewFyBxChaiLvPrint     = Url_Base + "ShenPiNewFyBxChaiLvPrint"
const Url_ShenPiNewFyBxChaiLvSH0     = Url_Base + "ShenPiNewFyBxChaiLvSH0"
const Url_ShenPiNewFyBxChaiLvSH1     = Url_Base + "ShenPiNewFyBxChaiLvSH1"
const Url_ShenPiNewFyBxChaiLvSH2     = Url_Base + "ShenPiNewFyBxChaiLvSH2"
const Url_ShenPiNewFyBxChaiLvSH3 = Url_Base + "ShenPiNewFyBxChaiLvSH3"
const Url_ShenPiNewFyBxChaiLvSH4 = Url_Base + "ShenPiNewFyBxChaiLvSH4"
const Url_ShenPiTongJi = Url_Base + "ShenPiTongJi"
//审核报销
const Url_AddShenPiBaoXiao     = Url_Base + "AddShenPiBaoXiao"
const Url_DelShenPiBaoXiao     = Url_Base + "DelShenPiBaoXiao"
const Url_GetShenPiBaoXiaoList = Url_Base + "GetShenPiBaoXiaoList"
const Url_GetShenPiBaoXiaoNum  = Url_Base + "GetShenPiBaoXiaoNum"
const Url_ShenPiBaoXiaoSH1     = Url_Base + "ShenPiBaoXiaoSH1"
const Url_ShenPiBaoXiaoSH2     = Url_Base + "ShenPiBaoXiaoSH2"
const Url_ShenPiBaoXiaoSH3     = Url_Base + "ShenPiBaoXiaoSH3"
const Url_ShenPiBaoXiaoSH4     = Url_Base + "ShenPiBaoXiaoSH4"
const Url_ChangeBaoXiaoPayStatus = Url_Base + "ChangeBaoXiaoPayStatus"
//审核费用
const Url_AddShenPiFeiYong       = Url_Base + "AddShenPiFeiYong"
const Url_DelShenPiFeiYong       = Url_Base + "DelShenPiFeiYong"
const Url_GetShenPiFeiYongList   = Url_Base + "GetShenPiFeiYongList"
const Url_GetShenPiFeiYongNum    = Url_Base + "GetShenPiFeiYongNum"
const Url_ShenPiFeiYongSH1       = Url_Base + "ShenPiFeiYongSH1"
const Url_ShenPiFeiYongSH2       = Url_Base + "ShenPiFeiYongSH2"
const Url_ShenPiFeiYongSH3       = Url_Base + "ShenPiFeiYongSH3"
const Url_ShenPiFeiYongSH4       = Url_Base + "ShenPiFeiYongSH4"
const Url_ChangeFeiYongPayStatus = Url_Base + "ChangeFeiYongPayStatus"
//审核用章
const Url_AddShenPiYongZhang     = Url_Base + "AddShenPiYongZhang"
const Url_DelShenPiYongZhang     = Url_Base + "DelShenPiYongZhang"
const Url_GetShenPiYongZhangList = Url_Base + "GetShenPiYongZhangList"
const Url_GetShenPiYongZhangNum  = Url_Base + "GetShenPiYongZhangNum"
const Url_ShenPiYongZhangSH1     = Url_Base + "ShenPiYongZhangSH1"
const Url_ShenPiYongZhangSH2     = Url_Base + "ShenPiYongZhangSH2"
//审核请假
const Url_AddShenPiQingJia     = Url_Base + "AddShenPiQingJia"
const Url_DelShenPiQingJia     = Url_Base + "DelShenPiQingJia"
const Url_EditShenPiQingJia    = Url_Base + "EditShenPiQingJia"
const Url_GetShenPiQingJiaList = Url_Base + "GetShenPiQingJiaList"
const Url_GetShenPiQingJiaNum  = Url_Base + "GetShenPiQingJiaNum"
const Url_ShenPiQingJiaSH1     = Url_Base + "ShenPiQingJiaSH1"
const Url_ShenPiQingJiaSH2     = Url_Base + "ShenPiQingJiaSH2"
const Url_ShenPiQingJiaSH3     = Url_Base + "ShenPiQingJiaSH3"
//审核出差
const Url_AddShenPiChuChai     = Url_Base + "AddShenPiChuChai"
const Url_DelShenPiChuChai     = Url_Base + "DelShenPiChuChai"
const Url_GetShenPiChuChaiList = Url_Base + "GetShenPiChuChaiList"
const Url_GetShenPiChuChaiNum  = Url_Base + "GetShenPiChuChaiNum"
const Url_ShenPiChuChaiSH1     = Url_Base + "ShenPiChuChaiSH1"
const Url_ShenPiChuChaiSH2     = Url_Base + "ShenPiChuChaiSH2"
const Url_ShenPiChuChaiSH3     = Url_Base + "ShenPiChuChaiSH3"
//审核招聘
const Url_AddShenPiZhaoPin     = Url_Base + "AddShenPiZhaoPin"
const Url_DelShenPiZhaoPin     = Url_Base + "DelShenPiZhaoPin"
const Url_GetShenPiZhaoPinList = Url_Base + "GetShenPiZhaoPinList"
const Url_GetShenPiZhaoPinNum  = Url_Base + "GetShenPiZhaoPinNum"
const Url_ShenPiZhaoPinSH1     = Url_Base + "ShenPiZhaoPinSH1"
const Url_ShenPiZhaoPinSH2     = Url_Base + "ShenPiZhaoPinSH2"
const Url_ShenPiZhaoPinSH3     = Url_Base + "ShenPiZhaoPinSH3"
//审核办公用品
const Url_AddShenPiBanGongYongPing     = Url_Base + "AddShenPiBanGongYongPing"
const Url_DelShenPiBanGongYongPing     = Url_Base + "DelShenPiBanGongYongPing"
const Url_GetShenPiBanGongYongPingList = Url_Base + "GetShenPiBanGongYongPingList"
const Url_GetShenPiBanGongYongPingNum  = Url_Base + "GetShenPiBanGongYongPingNum"
const Url_ShenPiBanGongYongPingSH1     = Url_Base + "ShenPiBanGongYongPingSH1"
const Url_ShenPiBanGongYongPingSH2     = Url_Base + "ShenPiBanGongYongPingSH2"
const Url_ChangeBanGongYongPingBuyStatus = Url_Base + "ChangeBanGongYongPingBuyStatus"
//审核创建机构
const Url_AddShenPiJiGou     = Url_Base + "AddShenPiJiGou"
const Url_EditShenPiJiGou     = Url_Base + "EditShenPiJiGou"
const Url_DelShenPiJiGou     = Url_Base + "DelShenPiJiGou"
const Url_GetShenPiJiGouList = Url_Base + "GetShenPiJiGouList"
const Url_GetShenPiJiGouNum  = Url_Base + "GetShenPiJiGouNum"
const Url_ShenPiJiGouSH1     = Url_Base + "ShenPiJiGouSH1"
const Url_ShenPiJiGouSH2     = Url_Base + "ShenPiJiGouSH2"
const Url_AddShenPiJiGouModify     = Url_Base + "AddShenPiJiGouModify"
const Url_DelShenPiJiGouModify     = Url_Base + "DelShenPiJiGouModify"
const Url_GetShenPiJiGouModifyList = Url_Base + "GetShenPiJiGouModifyList"
const Url_ShenPiJiGouModifySH1     = Url_Base + "ShenPiJiGouModifySH1"
const Url_ShenPiJiGouModifySH2     = Url_Base + "ShenPiJiGouModifySH2"
//文件
const Url_AddErp3File     = Url_Base + "AddErp3File"
const Url_DelErp3File     = Url_Base + "DelErp3File"
const Url_GetErp3FileList = Url_Base + "GetErp3FileList"
const Url_GetErp3FileNum  = Url_Base + "GetErp3FileNum"
const Url_EditErp3File    = Url_Base + "EditErp3File"
const Url_GetErp3FileList40 = Url_Base + "GetErp3FileList40"
const Url_GetErp3FileNum40  = Url_Base + "GetErp3FileNum40"
//员工生日
const Url_AddErp3StaffBirthday     = Url_Base + "AddErp3StaffBirthday"
const Url_EditErp3StaffBirthday    = Url_Base + "EditErp3StaffBirthday"
const Url_GetErp3StaffBirthdayList = Url_Base + "GetErp3StaffBirthdayList"
const Url_GetErp3StaffBirthdayNum  = Url_Base + "GetErp3StaffBirthdayNum"
const Url_GetErp3StaffBirthdayRecentlyList = Url_Base + "GetErp3StaffBirthdayRecentlyList"
//节日福利
const Url_AddErp3Holiday     = Url_Base + "AddErp3Holiday"
const Url_EditErp3Holiday    = Url_Base + "EditErp3Holiday"
const Url_GetErp3HolidayList = Url_Base + "GetErp3HolidayList"
const Url_GetErp3HolidayNum  = Url_Base + "GetErp3HolidayNum"
const Url_GetErp3HolidayRecentlyList = Url_Base + "GetErp3HolidayRecentlyList"
//微信商城
const Url_GetWxstoreUserList = Url_Base + "GetWxstoreUserList"
const Url_GetWxstoreUserNum  = Url_Base + "GetWxstoreUserNum"
const Url_GetWxstoreGoodsList = Url_Base + "GetWxstoreGoodsList"
const Url_GetWxstoreGoodsNum  = Url_Base + "GetWxstoreGoodsNum"
const Url_GetWxstoreSpeciesList  = Url_Base + "GetWxstoreSpeciesList"
const Url_AddWxstoreGoods  = Url_Base + "AddWxstoreGoods"
const Url_EditWxstoreGoods  = Url_Base + "EditWxstoreGoods"
const Url_ShangXiaJiaWxstoreGoods  = Url_Base + "ShangXiaJiaWxstoreGoods"
const Url_GetWxstoreOrderList  = Url_Base + "GetWxstoreOrderList"
const Url_GetWxstoreOrderNum  = Url_Base + "GetWxstoreOrderNum"
const Url_FaHuoWxstoreOrder  = Url_Base + "FaHuoWxstoreOrder"
//反馈单
const Url_GetFanKuiDanList  = Url_Base + "GetFanKuiDanList"
const Url_GetFanKuiDanNum  = Url_Base + "GetFanKuiDanNum"
const Url_AddFanKuiDan  = Url_Base + "AddFanKuiDan"
//协议模板
const Url_GetAgreementTemplateList  = Url_Base + "GetAgreementTemplateList"
const Url_GetAgreementTemplateNum  = Url_Base + "GetAgreementTemplateNum"
//协议备份
const Url_GetAgreementBackupList  = Url_Base + "GetAgreementBackupList"
const Url_GetAgreementBackupNum  = Url_Base + "GetAgreementBackupNum"
const Url_AddAgreementBackup  = Url_Base + "AddAgreementBackup"
//消息中心
const Url_GetMessageCenterUnreadList  = Url_Base + "GetMessageCenterUnreadList"
const Url_GetMessageCenterAllList  = Url_Base + "GetMessageCenterAllList"
const Url_GetMessageCenterAllNum  = Url_Base + "GetMessageCenterAllNum"
const Url_AddMessageCenter  = Url_Base + "AddMessageCenter"
const Url_CheckErpuser  = Url_Base + "CheckErpuser"
//库存操作
const Url_Addmadeorderkucun = Url_Base + "Addmadeorderkucun"
const Url_Getmadeorderkucun = Url_Base + "Getmadeorderkucun"
const Url_DeleteMadeOrderKucun = Url_Base + "DeleteMadeOrderKucun"
//工作台
const Url_Geterpuserneibulist = Url_Base + "Geterpuserneibulist"
const Url_GetWorkbenchsingleList = Url_Base + "GetWorkbenchsingleList"
const Url_GetWorkbenchsingleNum = Url_Base + "GetWorkbenchsingleNum"
const Url_AddWorkbenchsingle = Url_Base + "AddWorkbenchsingle"
const Url_DeleteWorkbenchsingle = Url_Base + "DeleteWorkbenchsingle"
const Url_PostWorkbenchsingleProgress = Url_Base + "PostWorkbenchsingleProgress"
const Url_GetWorkbenchLogreportList = Url_Base + "GetWorkbenchLogreportList"
const Url_GetWorkbenchStatisticalList = Url_Base + "GetWorkbenchStatisticalList"
const Url_GetWorkbenchStatisticalNum = Url_Base + "GetWorkbenchStatisticalNum"
const Url_DeleteWorkbenchStatistical = Url_Base + "DeleteWorkbenchStatistical"
const Url_PostWorkbenchStatisticalValuation = Url_Base + "PostWorkbenchStatisticalValuation"
//部门预决算
const Url_AddWorkdepartmentbudget = Url_Base + "AddWorkdepartmentbudget"
const Url_GetWorkdepartmentbudgetList = Url_Base + "GetWorkdepartmentbudgetList"
const Url_GetWorkdepartmentbudgetNum = Url_Base + "GetWorkdepartmentbudgetNum"
const Url_EditWorkdepartmentbudget = Url_Base + "EditWorkdepartmentbudget"
const Url_DeleteWorkdepartmentbudget = Url_Base + "DeleteWorkdepartmentbudget"
//部门预决算统计
const Url_GetWorkdepartmentbudgetstatisticalList = Url_Base + "GetWorkdepartmentbudgetstatisticalList"
const Url_GetWorkdepartmentbudgetstatisticalNum = Url_Base + "GetWorkdepartmentbudgetstatisticalNum"
//项目预决算
const Url_AddWorkprojectbudget = Url_Base + "AddWorkprojectbudget"
const Url_GetWorkprojectbudgetList = Url_Base + "GetWorkprojectbudgetList"
const Url_GetWorkprojectbudgetNum = Url_Base + "GetWorkprojectbudgetNum"
const Url_EditWorkprojectbudget = Url_Base + "EditWorkprojectbudget"
const Url_DeleteWorkprojectbudget = Url_Base + "DeleteWorkprojectbudget"
const Url_GetWorkprojectList = Url_Base + "GetWorkprojectList"
//项目预决算统计
const Url_GetWorkprojectbudgetstatisticalList = Url_Base + "GetWorkprojectbudgetstatisticalList"
const Url_GetWorkprojectbudgetstatisticalNum = Url_Base + "GetWorkprojectbudgetstatisticalNum"
//访客登记
const Url_AddVisitorslog = Url_Base + "AddVisitorslog"
const Url_GetVisitorslogList = Url_Base + "GetVisitorslogList"
const Url_GetVisitorslogNum = Url_Base + "GetVisitorslogNum"
const Url_DelVisitorslog = Url_Base + "DelVisitorslog"
//微盘
const Url_AddMicroDiskFile = Url_Base + "AddMicroDiskFile"
const Url_AddMicroDiskPermissions = Url_Base + "AddMicroDiskPermissions"
const Url_DelMicroDiskFile = Url_Base + "DelMicroDiskFile"
const Url_GetMicroDiskFileList = Url_Base + "GetMicroDiskFileList"
const Url_MoveMicroDiskFile = Url_Base + "MoveMicroDiskFile"
const Url_RenameMicroDiskFile = Url_Base + "RenameMicroDiskFile"
//BOM
const Url_AddProjectbom = Url_Base + "AddProjectbom"
const Url_AddProjectbomMain = Url_Base + "AddProjectbomMain"
const Url_DelProjectbom = Url_Base + "DelProjectbom"
const Url_EditProjectbom = Url_Base + "EditProjectbom"
const Url_Projectbomlist = Url_Base + "Projectbomlist"
const Url_Projectbomnum = Url_Base + "Projectbomnum"
const Url_CheckProjectbom = Url_Base + "CheckProjectbom"
//供应商价格档案
const Url_Addproductmoneysupplier = Url_Base + "Addproductmoneysupplier"
const Url_Deleteproductmoneysupplier = Url_Base + "Deleteproductmoneysupplier"
const Url_Editproductmoneysupplier = Url_Base + "Editproductmoneysupplier"
const Url_Editproductmoneysuppliershenhe = Url_Base + "Editproductmoneysuppliershenhe"
const Url_Getproductmoneysupplierlist = Url_Base + "Getproductmoneysupplierlist"
const Url_Getproductmoneysuppliernum = Url_Base + "Getproductmoneysuppliernum"
const Url_Checkproductmoneysupplier = Url_Base + "Checkproductmoneysupplier"
//研发专用价格档案
const Url_Addproductmoneyrd = Url_Base + "Addproductmoneyrd"
const Url_Deleteproductmoneyrd = Url_Base + "Deleteproductmoneyrd"
const Url_Editproductmoneyrd = Url_Base + "Editproductmoneyrd"
const Url_Editproductmoneyrdshenhe = Url_Base + "Editproductmoneyrdshenhe"
const Url_Getproductmoneyrdlist = Url_Base + "Getproductmoneyrdlist"
const Url_Getproductmoneyrdnum = Url_Base + "Getproductmoneyrdnum"
//研发专用价格档案
const Url_AddPersonpayroll = Url_Base + "AddPersonpayroll"
const Url_DelPersonpayroll = Url_Base + "DelPersonpayroll"
const Url_EditPersonpayroll = Url_Base + "EditPersonpayroll"
const Url_Personpayrolllist = Url_Base + "Personpayrolllist"
const Url_Personpayrollnum = Url_Base + "Personpayrollnum"
//ERP项目成本核算
const Url_EditProjectcost = Url_Base + "EditProjectcost"
const Url_Projectcostlist = Url_Base + "Projectcostlist"
//ERP新利润表
const Url_AddLiRunBiao = Url_Base + "AddLiRunBiao"
const Url_ErpLiRunBiaoList = Url_Base + "ErpLiRunBiaoList"
//ERP新现金日报
const Url_AddXianjinribao = Url_Base + "AddXianjinribao"
const Url_Xianjinribaolist = Url_Base + "Xianjinribaolist"
//部门费用汇总表
const Url_BumenfeiyonghuizongbiaoList = Url_Base + "BumenfeiyonghuizongbiaoList"
//不良品库存管理
const Url_Addmadedefectiveproductkucun = Url_Base + "Addmadedefectiveproductkucun"
const Url_Getmadedefectiveproductkucunlist = Url_Base + "Getmadedefectiveproductkucunlist"
const Url_Getmadedefectiveproductkucunnum = Url_Base + "Getmadedefectiveproductkucunnum"
//
const Url_GetReportYunyingshangSales = Url_Base + "GetReportYunyingshangSales"
//全国门店信息汇总表
const Url_AddGlassJigouInformation = Url_Base + "AddGlassJigouInformation"
const Url_EditGlassJigouInformation = Url_Base + "EditGlassJigouInformation"
const Url_ExcelImportGlassJigouInformation = Url_Base + "ExcelImportGlassJigouInformation"
const Url_GetGlassJigouInformationList = Url_Base + "GetGlassJigouInformationList"
const Url_GetGlassJigouInformationNum = Url_Base + "GetGlassJigouInformationNum"
const Url_GetGlassJigouSaleStatisticalList = Url_Base + "GetGlassJigouSaleStatisticalList"
//
const Url_AddDeviceClearPlLiang = Url_Base + "AddDeviceClearPlLiang"
const Url_GetDeviceClearPlLianglist = Url_Base + "GetDeviceClearPlLianglist"
const Url_GetDeviceClearPlLiangnum = Url_Base + "GetDeviceClearPlLiangnum"
const Url_ProcessDeviceClearPlLiang = Url_Base + "ProcessDeviceClearPlLiang"
//小睿智能筛查管家
const Url_GetMiniappShaichaWxuserList = Url_Base + "GetMiniappShaichaWxuserList"
const Url_GetMiniappShaichaWxuserNum = Url_Base + "GetMiniappShaichaWxuserNum"
const Url_SetMiniappShaichaWxuser = Url_Base + "SetMiniappShaichaWxuser"
const Url_GetMiniappShaichaWxuserListSub = Url_Base + "GetMiniappShaichaWxuserListSub"
const Url_GetMiniappShaichaVisionScreeningUserList = Url_Base + "GetMiniappShaichaVisionScreeningUserList"
const Url_GetMiniappShaichaVisionScreeningUserNum = Url_Base + "GetMiniappShaichaVisionScreeningUserNum"
const Url_GetMiniappShaichaVisionScreeningUserListSub = Url_Base + "GetMiniappShaichaVisionScreeningUserListSub"
const Url_AddMiniappShaichaVisionScreeningUser = Url_Base + "AddMiniappShaichaVisionScreeningUser"
const Url_AddMiniappShaichaStore = Url_Base + "AddMiniappShaichaStore"
const Url_DelMiniappShaichaStore = Url_Base + "DelMiniappShaichaStore"
const Url_EditMiniappShaichaStore = Url_Base + "EditMiniappShaichaStore"
const Url_GetMiniappShaichaStoreList = Url_Base + "GetMiniappShaichaStoreList"
const Url_GetMiniappShaichaStoreNum = Url_Base + "GetMiniappShaichaStoreNum"
//RSL-PT
const Url_AmapDirectionWalking = "https://apirsl.eyesreal.com:8686/ApiJ01/Amap/AmapDirectionWalking"
const Url_BmapDirectionWalking = "https://apirsl.eyesreal.com:8686/ApiJ01/Amap/BmapDirectionWalking"
const Url_Find100RSLPT = "https://apirsl.eyesreal.com:8686/ApiJ01/Amap/Find100RSLPT"
const Url_BmapRslptLog = "https://apirsl.eyesreal.com:8686/ApiJ01/Amap/BmapRslptLog"
const Url_GetNavMessage = "https://apirsl.eyesreal.com:8686/ApiJ01/RSLPT/GetNavMessage"
//睿世力控股集团有限公司-ERP
const Url_GetKgjtWebsiteErpProductList = Url_Base + "GetKgjtWebsiteErpProductList"
const Url_GetKgjtWebsiteErpProductNum = Url_Base + "GetKgjtWebsiteErpProductNum"
const Url_AddKgjtWebsiteErpProduct = Url_Base + "AddKgjtWebsiteErpProduct"
const Url_EditKgjtWebsiteErpProduct = Url_Base + "EditKgjtWebsiteErpProduct"
const Url_DelKgjtWebsiteErpProduct = Url_Base + "DelKgjtWebsiteErpProduct"
const Url_GetKgjtWebsiteErpProductCharacteristicsList = Url_Base + "GetKgjtWebsiteErpProductCharacteristicsList"
const Url_GetKgjtWebsiteErpProductCharacteristicsNum = Url_Base + "GetKgjtWebsiteErpProductCharacteristicsNum"
const Url_AddKgjtWebsiteErpProductCharacteristics = Url_Base + "AddKgjtWebsiteErpProductCharacteristics"
const Url_EditKgjtWebsiteErpProductCharacteristics = Url_Base + "EditKgjtWebsiteErpProductCharacteristics"
const Url_DelKgjtWebsiteErpProductCharacteristics = Url_Base + "DelKgjtWebsiteErpProductCharacteristics"
const Url_GetKgjtWebsiteErpProductColorList = Url_Base + "GetKgjtWebsiteErpProductColorList"
const Url_GetKgjtWebsiteErpProductColorNum = Url_Base + "GetKgjtWebsiteErpProductColorNum"
const Url_AddKgjtWebsiteErpProductColor = Url_Base + "AddKgjtWebsiteErpProductColor"
const Url_EditKgjtWebsiteErpProductColor = Url_Base + "EditKgjtWebsiteErpProductColor"
const Url_DelKgjtWebsiteErpProductColor = Url_Base + "DelKgjtWebsiteErpProductColor"
const Url_GetKgjtWebsiteErpProductInfoList = Url_Base + "GetKgjtWebsiteErpProductInfoList"
const Url_GetKgjtWebsiteErpProductInfoNum = Url_Base + "GetKgjtWebsiteErpProductInfoNum"
const Url_AddKgjtWebsiteErpProductInfo = Url_Base + "AddKgjtWebsiteErpProductInfo"
const Url_EditKgjtWebsiteErpProductInfo = Url_Base + "EditKgjtWebsiteErpProductInfo"
const Url_DelKgjtWebsiteErpProductInfo = Url_Base + "DelKgjtWebsiteErpProductInfo"
const Url_GetKgjtWebsiteOfflineOrderList = Url_Base + "GetKgjtWebsiteOfflineOrderList"
const Url_GetKgjtWebsiteOfflineOrderNum = Url_Base + "GetKgjtWebsiteOfflineOrderNum"
const Url_EditKgjtWebsiteOfflineOrderSubStatus = Url_Base + "EditKgjtWebsiteOfflineOrderSubStatus"
const Url_AddKgjtWebsiteOfflineOrderSend = Url_Base + "AddKgjtWebsiteOfflineOrderSend"
const Url_DelKgjtWebsiteOfflineOrderSend = Url_Base + "DelKgjtWebsiteOfflineOrderSend"
const Url_EditKgjtWebsiteOfflineOrderSend = Url_Base + "EditKgjtWebsiteOfflineOrderSend"
const Url_GetKgjtWebsiteOfflineOrderSendList = Url_Base + "GetKgjtWebsiteOfflineOrderSendList"
const Url_GetKgjtWebsiteOfflineOrderSendNum = Url_Base + "GetKgjtWebsiteOfflineOrderSendNum"
const Url_AddKgjtWebsiteOfflineOrderInvoice = Url_Base + "AddKgjtWebsiteOfflineOrderInvoice"
const Url_DelKgjtWebsiteOfflineOrderInvoice = Url_Base + "DelKgjtWebsiteOfflineOrderInvoice"
const Url_EditKgjtWebsiteOfflineOrderInvoice = Url_Base + "EditKgjtWebsiteOfflineOrderInvoice"
const Url_GetKgjtWebsiteOfflineOrderInvoiceList = Url_Base + "GetKgjtWebsiteOfflineOrderInvoiceList"
const Url_GetKgjtWebsiteOfflineOrderInvoiceNum = Url_Base + "GetKgjtWebsiteOfflineOrderInvoiceNum"
const Url_AddKgjtWebsiteAnnouncement = Url_Base + "AddKgjtWebsiteAnnouncement"
const Url_EditKgjtWebsiteAnnouncement = Url_Base + "EditKgjtWebsiteAnnouncement"
const Url_DelKgjtWebsiteAnnouncement = Url_Base + "DelKgjtWebsiteAnnouncement"
const Url_GetKgjtWebsiteAnnouncementList = Url_Base + "GetKgjtWebsiteAnnouncementList"
const Url_GetKgjtWebsiteAnnouncementNum = Url_Base + "GetKgjtWebsiteAnnouncementNum"
const Url_GetKgjtWebsiteBodyCheckList = Url_Base + "GetKgjtWebsiteBodyCheckList"
const Url_GetKgjtWebsiteBodyCheckNum = Url_Base + "GetKgjtWebsiteBodyCheckNum"
const Url_AddKgjtWebsiteProductEvolution = Url_Base + "AddKgjtWebsiteProductEvolution"
const Url_EditKgjtWebsiteProductEvolution = Url_Base + "EditKgjtWebsiteProductEvolution"
const Url_DelKgjtWebsiteProductEvolution = Url_Base + "DelKgjtWebsiteProductEvolution"
const Url_GetKgjtWebsiteProductEvolutionList = Url_Base + "GetKgjtWebsiteProductEvolutionList"
const Url_GetKgjtWebsiteProductEvolutionNum = Url_Base + "GetKgjtWebsiteProductEvolutionNum"
const Url_AddKgjtWebsiteNews = Url_Base + "AddKgjtWebsiteNews"
const Url_EditKgjtWebsiteNews = Url_Base + "EditKgjtWebsiteNews"
const Url_DelKgjtWebsiteNews = Url_Base + "DelKgjtWebsiteNews"
const Url_GetKgjtWebsiteNewsList = Url_Base + "GetKgjtWebsiteNewsList"
const Url_GetKgjtWebsiteNewsNum = Url_Base + "GetKgjtWebsiteNewsNum"
const Url_AddKgjtWebsiteNewsPic = Url_Base + "AddKgjtWebsiteNewsPic"
const Url_EditKgjtWebsiteNewsPic = Url_Base + "EditKgjtWebsiteNewsPic"
const Url_DelKgjtWebsiteNewsPic = Url_Base + "DelKgjtWebsiteNewsPic"
const Url_GetKgjtWebsiteNewsPicList = Url_Base + "GetKgjtWebsiteNewsPicList"
const Url_GetKgjtWebsiteNewsPicNum = Url_Base + "GetKgjtWebsiteNewsPicNum"
const Url_AddKgjtWebsiteLearnVideo = Url_Base + "AddKgjtWebsiteLearnVideo"
const Url_EditKgjtWebsiteLearnVideo = Url_Base + "EditKgjtWebsiteLearnVideo"
const Url_DelKgjtWebsiteLearnVideo = Url_Base + "DelKgjtWebsiteLearnVideo"
const Url_GetKgjtWebsiteLearnVideoList = Url_Base + "GetKgjtWebsiteLearnVideoList"
const Url_GetKgjtWebsiteLearnVideoNum = Url_Base + "GetKgjtWebsiteLearnVideoNum"
const Url_GetKgjtWebsiteConsultingList = Url_Base + "GetKgjtWebsiteConsultingList"
const Url_GetKgjtWebsiteConsultingNum = Url_Base + "GetKgjtWebsiteConsultingNum"
const Url_GetKgjtWebsiteOnlineMessageList = Url_Base + "GetKgjtWebsiteOnlineMessageList"
const Url_GetKgjtWebsiteOnlineMessageNum = Url_Base + "GetKgjtWebsiteOnlineMessageNum"
const Url_AddKgjtWebsiteGeneralInformation = Url_Base + "AddKgjtWebsiteGeneralInformation"
const Url_EditKgjtWebsiteGeneralInformation = Url_Base + "EditKgjtWebsiteGeneralInformation"
const Url_DelKgjtWebsiteGeneralInformation = Url_Base + "DelKgjtWebsiteGeneralInformation"
const Url_GetKgjtWebsiteGeneralInformationList = Url_Base + "GetKgjtWebsiteGeneralInformationList"
const Url_GetKgjtWebsiteGeneralInformationNum = Url_Base + "GetKgjtWebsiteGeneralInformationNum"
const Url_AddKgjtWebsiteHonor = Url_Base + "AddKgjtWebsiteHonor"
const Url_EditKgjtWebsiteHonor = Url_Base + "EditKgjtWebsiteHonor"
const Url_DelKgjtWebsiteHonor = Url_Base + "DelKgjtWebsiteHonor"
const Url_GetKgjtWebsiteHonorList = Url_Base + "GetKgjtWebsiteHonorList"
const Url_GetKgjtWebsiteHonorNum = Url_Base + "GetKgjtWebsiteHonorNum"
const Url_AddKgjtWebsiteExperts = Url_Base + "AddKgjtWebsiteExperts"
const Url_EditKgjtWebsiteExperts = Url_Base + "EditKgjtWebsiteExperts"
const Url_DelKgjtWebsiteExperts = Url_Base + "DelKgjtWebsiteExperts"
const Url_GetKgjtWebsiteExpertsList = Url_Base + "GetKgjtWebsiteExpertsList"
const Url_GetKgjtWebsiteExpertsNum = Url_Base + "GetKgjtWebsiteExpertsNum"
const Url_AddKgjtWebsiteExpertsInfo = Url_Base + "AddKgjtWebsiteExpertsInfo"
const Url_EditKgjtWebsiteExpertsInfo = Url_Base + "EditKgjtWebsiteExpertsInfo"
const Url_DelKgjtWebsiteExpertsInfo = Url_Base + "DelKgjtWebsiteExpertsInfo"
const Url_GetKgjtWebsiteExpertsInfoList = Url_Base + "GetKgjtWebsiteExpertsInfoList"
const Url_GetKgjtWebsiteExpertsInfoNum = Url_Base + "GetKgjtWebsiteExpertsInfoNum"
const Url_AddKgjtWebsiteTalentStrategy = Url_Base + "AddKgjtWebsiteTalentStrategy"
const Url_EditKgjtWebsiteTalentStrategy = Url_Base + "EditKgjtWebsiteTalentStrategy"
const Url_DelKgjtWebsiteTalentStrategy = Url_Base + "DelKgjtWebsiteTalentStrategy"
const Url_GetKgjtWebsiteTalentStrategyList = Url_Base + "GetKgjtWebsiteTalentStrategyList"
const Url_GetKgjtWebsiteTalentStrategyNum = Url_Base + "GetKgjtWebsiteTalentStrategyNum"
const Url_GetKgjtWebsiteSubsidiaryCompanyList = Url_Base + "GetKgjtWebsiteSubsidiaryCompanyList"
const Url_GetKgjtWebsiteSubsidiaryCompanyNum = Url_Base + "GetKgjtWebsiteSubsidiaryCompanyNum"
const Url_EditKgjtWebsiteSubsidiaryCompany = Url_Base + "EditKgjtWebsiteSubsidiaryCompany"
const Url_AddKgjtWebsiteProductRecommend = Url_Base + "AddKgjtWebsiteProductRecommend"
const Url_EditKgjtWebsiteProductRecommend = Url_Base + "EditKgjtWebsiteProductRecommend"
const Url_DelKgjtWebsiteProductRecommend = Url_Base + "DelKgjtWebsiteProductRecommend"
const Url_GetKgjtWebsiteProductRecommendList = Url_Base + "GetKgjtWebsiteProductRecommendList"
const Url_GetKgjtWebsiteProductRecommendNum = Url_Base + "GetKgjtWebsiteProductRecommendNum"
// 20220728 获取当前用户的所有账号
const Url_SystemSetAdminsGetMyAcounts = Url_Base + "SystemSetAdminsGetMyAcounts"
//
const Url_AuxiliaryToolWorkWeixinMessageText = Url_Base + "AuxiliaryToolWorkWeixinMessageText"
// 小睿地推
const Url_AddMiniAppRuiDiTuiActivity = Url_Base + "AddMiniAppRuiDiTuiActivity"
const Url_EditMiniAppRuiDiTuiActivity = Url_Base + "EditMiniAppRuiDiTuiActivity"
const Url_GetMiniAppRuiDiTuiActivityList = Url_Base + "GetMiniAppRuiDiTuiActivityList"
const Url_GetMiniAppRuiDiTuiActivityNum = Url_Base + "GetMiniAppRuiDiTuiActivityNum"
const Url_AddMiniAppRuiDiTuiPromoters = Url_Base + "AddMiniAppRuiDiTuiPromoters"
const Url_EditMiniAppRuiDiTuiPromoters = Url_Base + "EditMiniAppRuiDiTuiPromoters"
const Url_GetMiniAppRuiDiTuiPromotersList = Url_Base + "GetMiniAppRuiDiTuiPromotersList"
const Url_GetMiniAppRuiDiTuiPromotersNum = Url_Base + "GetMiniAppRuiDiTuiPromotersNum"
const Url_GetMiniAppRuiDiTuiExperienceList = Url_Base + "GetMiniAppRuiDiTuiExperienceList"
const Url_GetMiniAppRuiDiTuiExperienceNum = Url_Base + "GetMiniAppRuiDiTuiExperienceNum"
// RSL-EV
const Url_RslEvLogin = Url_Base + "RslEvLogin"
const Url_RslEvCheckLogin = Url_Base + "RslEvCheckLogin"
const Url_RslEvGetUser = Url_Base + "RslEvGetUser"
const Url_RslEvAddUser = Url_Base + "RslEvAddUser"
const Url_RslEvAddCpuId = Url_Base + "RslEvAddCpuId"
const Url_RslEvBindGlassAndUser = Url_Base + "RslEvBindGlassAndUser"
const Url_RslEvAddCpuIdTime = Url_Base + "RslEvAddCpuIdTime"
const Url_RslEvPostSetDiopterLog = Url_Base + "RslEvPostSetDiopterLog"
const Url_GetRslEvUserList = Url_Base + "GetRslEvUserList"
const Url_GetRslEvUserNum = Url_Base + "GetRslEvUserNum"
const Url_GetRslEvFuChaList = Url_Base + "GetRslEvFuChaList"
const Url_GetRslEvFuChaNum = Url_Base + "GetRslEvFuChaNum"
const Url_AddRslEvFuCha = Url_Base + "AddRslEvFuCha"
const Url_EditRslEvFuCha = Url_Base + "EditRslEvFuCha"
// 校园视力筛查系统
const Url_AddRuischoolscUser = Url_Base + "AddRuischoolscUser"
const Url_DelRuischoolscUser = Url_Base + "DelRuischoolscUser"
const Url_EditRuischoolscUser = Url_Base + "EditRuischoolscUser"
const Url_GetRuischoolscDushuList = Url_Base + "GetRuischoolscDushuList"
const Url_GetRuischoolscUserList = Url_Base + "GetRuischoolscUserList"
const Url_GetRuischoolscUserNum = Url_Base + "GetRuischoolscUserNum"
// 配镜-预付款
const Url_AddOptometristYuFuKuan = Url_Base + "AddOptometristYuFuKuan"
const Url_OptometristYuFuKuanlist = Url_Base + "OptometristYuFuKuanlist"
const Url_OptometristYuFuKuannum = Url_Base + "OptometristYuFuKuannum"
// 配镜-预付款入账明细
const Url_OptometristYuFuKuanInList = Url_Base + "OptometristYuFuKuanInList"
const Url_OptometristYuFuKuanInNum = Url_Base + "OptometristYuFuKuanInNum"
// 配镜-预付款支出明细
const Url_OptometristYuFuKuanOutList = Url_Base + "OptometristYuFuKuanOutList"
const Url_OptometristYuFuKuanOutNum = Url_Base + "OptometristYuFuKuanOutNum"
// 配镜-处方单
const Url_AddOptometristPrescriptions = Url_Base + "AddOptometristPrescriptions"
const Url_DelOptometristPrescriptions = Url_Base + "DelOptometristPrescriptions"
const Url_EditOptometristPrescriptions = Url_Base + "EditOptometristPrescriptions"
const Url_GetOptometristPrescriptionsInfo = Url_Base + "GetOptometristPrescriptionsInfo"
const Url_GetOptometristPrescriptionsLastAddress = Url_Base + "GetOptometristPrescriptionsLastAddress"
const Url_GetOptometristPrescriptionsList = Url_Base + "GetOptometristPrescriptionsList"
const Url_GetOptometristPrescriptionsNum = Url_Base + "GetOptometristPrescriptionsNum"
const Url_GetOptometristProcessCost = Url_Base + "GetOptometristProcessCost"
const Url_GetOptometristInsurance = Url_Base + "GetOptometristInsurance"
const Url_GetOptometristUrgentFee = Url_Base + "GetOptometristUrgentFee"
const Url_SendOptometristPrescriptions = Url_Base + "SendOptometristPrescriptions"
const Url_ConfirmGoodsOptometristPrescriptions = Url_Base + "ConfirmGoodsOptometristPrescriptions"
const Url_NoOnlinePayOptometristPrescriptions = Url_Base + "NoOnlinePayOptometristPrescriptions"
// 配镜-分类
const Url_GetOptometristSuppliersClassification = Url_Base + "GetOptometristSuppliersClassification"
// 配镜-进货
const Url_GetOptometristProductinPrice = Url_Base + "GetOptometristProductinPrice"
const Url_AddOptometristProductin = Url_Base + "AddOptometristProductin"
const Url_DelOptometristProductin = Url_Base + "DelOptometristProductin"
const Url_EditOptometristProductin = Url_Base + "EditOptometristProductin"
const Url_GetOptometristProductinList = Url_Base + "GetOptometristProductinList"
const Url_GetOptometristProductinNum = Url_Base + "GetOptometristProductinNum"
// 配镜-出货
const Url_AddOptometristProductout = Url_Base + "AddOptometristProductout"
const Url_DelOptometristProductout = Url_Base + "DelOptometristProductout"
const Url_EditOptometristProductout = Url_Base + "EditOptometristProductout"
const Url_GetOptometristProductoutList = Url_Base + "GetOptometristProductoutList"
const Url_GetOptometristProductoutNum = Url_Base + "GetOptometristProductoutNum"
const Url_ConfirmGoodsOptometristProductout = Url_Base + "ConfirmGoodsOptometristProductout"
// 配镜-订单
const Url_EditOptometristOrder = Url_Base + "EditOptometristOrder"
const Url_GetOptometristOrderList = Url_Base + "GetOptometristOrderList"
const Url_GetOptometristOrderNum = Url_Base + "GetOptometristOrderNum"
// 配镜-库存
const Url_GetOptometristSuppliersList = Url_Base + "GetOptometristSuppliersList"
const Url_GetOptometristSuppliersNum = Url_Base + "GetOptometristSuppliersNum"
const Url_EditOptometristSuppliersSpike = Url_Base + "EditOptometristSuppliersSpike"
const Url_EditOptometristSuppliersInfo = Url_Base + "EditOptometristSuppliersInfo"
const Url_EditOptometristSuppliersProcessCost = Url_Base + "EditOptometristSuppliersProcessCost"
const Url_EditOptometristSuppliersInsurance = Url_Base + "EditOptometristSuppliersInsurance"
//批量下架
const Url_PiLiangXiaJiaOptometristSuppliers = Url_Base + "PiLiangXiaJiaOptometristSuppliers"
// 配镜-套餐组合
const Url_AddOptometristPackage = Url_Base + "AddOptometristPackage"
const Url_DelOptometristPackage = Url_Base + "DelOptometristPackage"
const Url_EditOptometristPackage = Url_Base + "EditOptometristPackage"
const Url_GetOptometristPackageList = Url_Base + "GetOptometristPackageList"
const Url_GetOptometristPackageNum = Url_Base + "GetOptometristPackageNum"
// 配镜-微信用户
const Url_GetOptometristWxUserList = Url_Base + "GetOptometristWxUserList"
const Url_GetOptometristWxUserNum = Url_Base + "GetOptometristWxUserNum"
// 自动问答
const Url_AddAutoQaMain = Url_Base + "AddAutoQaMain"
const Url_DelAutoQaMain = Url_Base + "DelAutoQaMain"
const Url_EditAutoQaMain = Url_Base + "EditAutoQaMain"
const Url_GetAutoQaMainList = Url_Base + "GetAutoQaMainList"
const Url_GetAutoQaMainNum = Url_Base + "GetAutoQaMainNum"
// 自动问答日志
const Url_GetAutoQaLogList = Url_Base + "GetAutoQaLogList"
const Url_GetAutoQaLogNum = Url_Base + "GetAutoQaLogNum"
// 可以给所有用户使用的接口
const Url_DiopterStateCalculator = Url_Base + "DiopterStateCalculator"
// 提现审批
const Url_WithdrawalMonthlyStatistics = Url_Base + "WithdrawalMonthlyStatistics"
// 登录
const Url_GetLogErpLoginList = Url_Base + "GetLogErpLoginList"
const Url_GetLogErpLoginNum = Url_Base + "GetLogErpLoginNum"
// RSL-EV设备管理
const Url_GetRslEvDeviceList = Url_Base + "GetRslEvDeviceList"
const Url_GetRslEvDeviceNum = Url_Base + "GetRslEvDeviceNum"
const Url_GetRslEvCpuidTimeList = Url_Base + "GetRslEvCpuidTimeList"
const Url_GetRslEvCpuidTimeNum = Url_Base + "GetRslEvCpuidTimeNum"
const Url_GetRslevCpuidSetdiopterList = Url_Base + "GetRslevCpuidSetdiopterList"
const Url_GetRslevCpuidSetdiopterNum = Url_Base + "GetRslevCpuidSetdiopterNum"
const Url_GetRslEvUserTimeList = Url_Base + "GetRslEvUserTimeList"
const Url_GetRslEvUserTimeNum = Url_Base + "GetRslEvUserTimeNum"
// RSL-EV用户管理
const Url_RuiYunGetRslEvUserList = Url_Base + "RuiYunGetRslEvUserList"
const Url_RuiYunGetRslEvUserNum = Url_Base + "RuiYunGetRslEvUserNum"
const Url_RuiYunGetRslEvFuChaList = Url_Base + "RuiYunGetRslEvFuChaList"
const Url_RuiYunGetRslEvFuChaNum = Url_Base + "RuiYunGetRslEvFuChaNum"
const Url_RuiYunAddRslEvFuCha = Url_Base + "RuiYunAddRslEvFuCha"
const Url_RuiYunEditRslEvFuCha = Url_Base + "RuiYunEditRslEvFuCha"
// 训练软件
const Url_GetXunLianUsersList = Url_Base + "GetXunLianUsersList"
const Url_GetXunLianUsersNum = Url_Base + "GetXunLianUsersNum"
const Url_EditXunLianUsers = Url_Base + "EditXunLianUsers"
const Url_GetXunLianUsersPermissions = Url_Base + "GetXunLianUsersPermissions"
const Url_EditXunLianUsersPermissions = Url_Base + "EditXunLianUsersPermissions"
// IP地址库
const Url_GetIpAddressList = Url_Base + "GetIpAddressList"
const Url_GetIpAddressNum = Url_Base + "GetIpAddressNum"
const Url_EditIpAddress = Url_Base + "EditIpAddress"
// 广州睿眼进销存 产品目录
const Url_AddNaoxjStockCatalog = Url_Base + "AddNaoxjStockCatalog"
const Url_EditNaoxjStockCatalog = Url_Base + "EditNaoxjStockCatalog"
const Url_GetNaoxjStockCataloglist = Url_Base + "GetNaoxjStockCataloglist"
const Url_GetNaoxjStockCatalognum = Url_Base + "GetNaoxjStockCatalognum"
const Url_GetNaoxjStockCatalogNameList = Url_Base + "GetNaoxjStockCatalogNameList"
const Url_GetNaoxjStockCatalogBeizhuoutList = Url_Base + "GetNaoxjStockCatalogBeizhuoutList"
// 广州睿眼进销存 进货
const Url_AddNaoxjStockStock = Url_Base + "AddNaoxjStockStock"
const Url_EditNaoxjStockStock = Url_Base + "EditNaoxjStockStock"
const Url_GetNaoxjStockStocklist = Url_Base + "GetNaoxjStockStocklist"
const Url_GetNaoxjStockStocknum = Url_Base + "GetNaoxjStockStocknum"
//广州睿眼进销存 销售
const Url_GetNaoxjStockSaleJiaGe = Url_Base + "GetNaoxjStockSaleJiaGe"
const Url_AddNaoxjStockSale = Url_Base + "AddNaoxjStockSale"
const Url_GetNaoxjStockSalelist = Url_Base + "GetNaoxjStockSalelist"
const Url_GetNaoxjStockSalenum = Url_Base + "GetNaoxjStockSalenum"
const Url_DeleteNaoxjStockSale = Url_Base + "DeleteNaoxjStockSale"
const Url_GetNaoxjStockSaleByOrderid = Url_Base + "GetNaoxjStockSaleByOrderid"
const Url_EditNaoxjStockSale  = Url_Base + "EditNaoxjStockSale"
const Url_EditNaoxjStockSaleSn  = Url_Base + "EditNaoxjStockSaleSn"
const Url_GetNaoxjStockSaleSubByOrderid  = Url_Base + "GetNaoxjStockSaleSubByOrderid"
const Url_AddNaoxjStockSaleSend  = Url_Base + "AddNaoxjStockSaleSend"
const Url_DeleteNaoxjStockSaleSend  = Url_Base + "DeleteNaoxjStockSaleSend"
const Url_GetNaoxjStockSaleSendlist  = Url_Base + "GetNaoxjStockSaleSendlist"
const Url_CaiWuShenPiNaoxjStockSale  = Url_Base + "CaiWuShenPiNaoxjStockSale"
//广州睿眼进销存 库存
const Url_NaoxjStockInventoryList = Url_Base + "NaoxjStockInventoryList"
//广州睿眼进销存 统计品类
const Url_NaoxjStockStatisticsCategoryList = Url_Base + "NaoxjStockStatisticsCategoryList"
const Url_NaoxjStockStatisticsSalesmanList = Url_Base + "NaoxjStockStatisticsSalesmanList"
const Url_NaoxjStockStatisticsClientList = Url_Base + "NaoxjStockStatisticsClientList"
//派视明-登录
const Url_ThirdPsmLogin = Url_Base + "ThirdPsmLogin"
const Url_ThirdPsmCheckLogin = Url_Base + "ThirdPsmCheckLogin"
//派视明-机构管理
const Url_AddThirdPsmJiGou = Url_Base + "AddThirdPsmJiGou"
const Url_EditThirdPsmJiGou = Url_Base + "EditThirdPsmJiGou"
const Url_GetThirdPsmJiGouList = Url_Base + "GetThirdPsmJiGouList"
const Url_GetThirdPsmJiGouNum = Url_Base + "GetThirdPsmJiGouNum"
//广州睿眼-眼运动-ERP
const Url_YanYunDongProductsAdd = Url_Base + "YanYunDongProductsAdd"
const Url_YanYunDongProductsEdit = Url_Base + "YanYunDongProductsEdit"
const Url_YanYunDongProductsGetList = Url_Base + "YanYunDongProductsGetList"
const Url_YanYunDongProductsGetNum = Url_Base + "YanYunDongProductsGetNum"
const Url_YanYunDongProductsShangXiaJia = Url_Base + "YanYunDongProductsShangXiaJia"
const Url_YanYunDongOrderProductGetList = Url_Base + "YanYunDongOrderProductGetList"
const Url_YanYunDongOrderProductGetNum = Url_Base + "YanYunDongOrderProductGetNum"
const Url_YanYunDongOrderProductEdit = Url_Base + "YanYunDongOrderProductEdit"
const Url_YanYunDongOrderYearlyPaymentGetList = Url_Base + "YanYunDongOrderYearlyPaymentGetList"
const Url_YanYunDongOrderYearlyPaymentGetNum = Url_Base + "YanYunDongOrderYearlyPaymentGetNum"
const Url_YanYunDongOrderUnlockDegreeGetList = Url_Base + "YanYunDongOrderUnlockDegreeGetList"
const Url_YanYunDongOrderUnlockDegreeGetNum = Url_Base + "YanYunDongOrderUnlockDegreeGetNum"
const Url_YanYunDongWxUserGetList = Url_Base + "YanYunDongWxUserGetList"
const Url_YanYunDongWxUserGetNum = Url_Base + "YanYunDongWxUserGetNum"
const Url_YanYunDongWxUserChangeYeWuYuan = Url_Base + "YanYunDongWxUserChangeYeWuYuan"
const Url_YanYunDongGlassuserGetList = Url_Base + "YanYunDongGlassuserGetList"
const Url_YanYunDongGlassuserGetNum = Url_Base + "YanYunDongGlassuserGetNum"
const Url_YanYunDongGlassuserNewSn = Url_Base + "YanYunDongGlassuserNewSn"
const Url_YanYunDongGlassuserAdd = Url_Base + "YanYunDongGlassuserAdd"
const Url_YanYunDongGlassuserUnbind = Url_Base + "YanYunDongGlassuserUnbind"
const Url_YanYunDongGlassuserOldSnGetList = Url_Base + "YanYunDongGlassuserOldSnGetList"
//广州睿眼-睿世力购物-ERP
const Url_RuiShiLiGouWuProductsAdd = Url_Base + "RuiShiLiGouWuProductsAdd"
const Url_RuiShiLiGouWuProductsEdit = Url_Base + "RuiShiLiGouWuProductsEdit"
const Url_RuiShiLiGouWuProductsGetList = Url_Base + "RuiShiLiGouWuProductsGetList"
const Url_RuiShiLiGouWuProductsGetNum = Url_Base + "RuiShiLiGouWuProductsGetNum"
const Url_RuiShiLiGouWuProductsShangXiaJia = Url_Base + "RuiShiLiGouWuProductsShangXiaJia"
const Url_RuiShiLiGouWuOrderProductGetList = Url_Base + "RuiShiLiGouWuOrderProductGetList"
const Url_RuiShiLiGouWuOrderProductGetNum = Url_Base + "RuiShiLiGouWuOrderProductGetNum"
const Url_RuiShiLiGouWuOrderProductEdit = Url_Base + "RuiShiLiGouWuOrderProductEdit"
const Url_RuiShiLiGouWuOrderYearlyPaymentGetList = Url_Base + "RuiShiLiGouWuOrderYearlyPaymentGetList"
const Url_RuiShiLiGouWuOrderYearlyPaymentGetNum = Url_Base + "RuiShiLiGouWuOrderYearlyPaymentGetNum"
const Url_RuiShiLiGouWuOrderUnlockDegreeGetList = Url_Base + "RuiShiLiGouWuOrderUnlockDegreeGetList"
const Url_RuiShiLiGouWuOrderUnlockDegreeGetNum = Url_Base + "RuiShiLiGouWuOrderUnlockDegreeGetNum"
const Url_RuiShiLiGouWuWxUserGetList = Url_Base + "RuiShiLiGouWuWxUserGetList"
const Url_RuiShiLiGouWuWxUserGetNum = Url_Base + "RuiShiLiGouWuWxUserGetNum"
const Url_RuiShiLiGouWuWxUserChangeYeWuYuan = Url_Base + "RuiShiLiGouWuWxUserChangeYeWuYuan"
const Url_RuiShiLiGouWuGlassuserGetList = Url_Base + "RuiShiLiGouWuGlassuserGetList"
const Url_RuiShiLiGouWuGlassuserGetNum = Url_Base + "RuiShiLiGouWuGlassuserGetNum"
const Url_RuiShiLiGouWuGlassuserNewSn = Url_Base + "RuiShiLiGouWuGlassuserNewSn"
const Url_RuiShiLiGouWuGlassuserAdd = Url_Base + "RuiShiLiGouWuGlassuserAdd"
const Url_RuiShiLiGouWuGlassuserUnbind = Url_Base + "RuiShiLiGouWuGlassuserUnbind"
const Url_RuiShiLiGouWuGlassuserOldSnGetList = Url_Base + "RuiShiLiGouWuGlassuserOldSnGetList"
// 20240401 新增管理->采购管理
const Url_GetErp6ProjectNameList = Url_Base + "GetErp6ProjectNameList"
const Url_GetErp6BomList = Url_Base + "GetErp6BomList"
const Url_GetErp6BomDanCaiList = Url_Base + "GetErp6BomDanCaiList"
const Url_GetErp6SupplierProfileList = Url_Base + "GetErp6SupplierProfileList"
const Url_GetErp6SupplierProfileListByCode = Url_Base + "GetErp6SupplierProfileListByCode"
const Url_AddErp6PurchaseOrder = Url_Base + "AddErp6PurchaseOrder"
const Url_DelErp6PurchaseOrder = Url_Base + "DelErp6PurchaseOrder"
const Url_EditErp6PurchaseOrder = Url_Base + "EditErp6PurchaseOrder"
const Url_GetErp6PurchaseOrderNum = Url_Base + "GetErp6PurchaseOrderNum"
const Url_GetErp6PurchaseOrderList = Url_Base + "GetErp6PurchaseOrderList"
const Url_ShenPiErp6PurchaseOrder0 = Url_Base + "ShenPiErp6PurchaseOrder0"
const Url_ShenPiErp6PurchaseOrder1 = Url_Base + "ShenPiErp6PurchaseOrder1"
const Url_ShenPiErp6PurchaseOrder2 = Url_Base + "ShenPiErp6PurchaseOrder2"
const Url_ShenPiErp6PurchaseOrder3 = Url_Base + "ShenPiErp6PurchaseOrder3"
const Url_ShenPiErp6PurchaseOrder4 = Url_Base + "ShenPiErp6PurchaseOrder4"
const Url_AddErp6PurchaseOrderFuKuanShenHe = Url_Base + "AddErp6PurchaseOrderFuKuanShenHe"
const Url_DelErp6PurchaseOrderFuKuanShenHe = Url_Base + "DelErp6PurchaseOrderFuKuanShenHe"
const Url_EditErp6PurchaseOrderFuKuanShenHe = Url_Base + "EditErp6PurchaseOrderFuKuanShenHe"
const Url_GetErp6PurchaseOrderFuKuanShenHeNum = Url_Base + "GetErp6PurchaseOrderFuKuanShenHeNum"
const Url_GetErp6PurchaseOrderFuKuanShenHeList = Url_Base + "GetErp6PurchaseOrderFuKuanShenHeList"
const Url_ShenPiErp6PurchaseOrderFuKuanShenHe0 = Url_Base + "ShenPiErp6PurchaseOrderFuKuanShenHe0"
const Url_ShenPiErp6PurchaseOrderFuKuanShenHe1 = Url_Base + "ShenPiErp6PurchaseOrderFuKuanShenHe1"
const Url_ShenPiErp6PurchaseOrderFuKuanShenHe2 = Url_Base + "ShenPiErp6PurchaseOrderFuKuanShenHe2"
const Url_ShenPiErp6PurchaseOrderFuKuanShenHe3 = Url_Base + "ShenPiErp6PurchaseOrderFuKuanShenHe3"
const Url_ShenPiErp6PurchaseOrderFuKuanShenHeChuNa = Url_Base + "ShenPiErp6PurchaseOrderFuKuanShenHeChuNa"
const Url_AddErp6PurchaseOrderDelivery = Url_Base + "AddErp6PurchaseOrderDelivery"
const Url_GetErp6PurchaseOrderDeliveryNum = Url_Base + "GetErp6PurchaseOrderDeliveryNum"
const Url_GetErp6PurchaseOrderDeliveryList = Url_Base + "GetErp6PurchaseOrderDeliveryList"
const Url_Erp6PurchaseOrderSignboard = Url_Base + "Erp6PurchaseOrderSignboard"
// 20240423 新增管理->销售管理
const Url_AddErp6SaleBaseProductPrice = Url_Base + "AddErp6SaleBaseProductPrice"
const Url_DelErp6SaleBaseProductPrice = Url_Base + "DelErp6SaleBaseProductPrice"
const Url_EditErp6SaleBaseProductPrice = Url_Base + "EditErp6SaleBaseProductPrice"
const Url_GetErp6SaleBaseProductPriceList = Url_Base + "GetErp6SaleBaseProductPriceList"
const Url_GetErp6SaleBaseProductPriceNum = Url_Base + "GetErp6SaleBaseProductPriceNum"
const Url_GetErp6SaleBaseProductPriceByProjectcode = Url_Base + "GetErp6SaleBaseProductPriceByProjectcode"
const Url_AddErp6SaleBaseSalesTeam = Url_Base + "AddErp6SaleBaseSalesTeam"
const Url_DelErp6SaleBaseSalesTeam = Url_Base + "DelErp6SaleBaseSalesTeam"
const Url_EditErp6SaleBaseSalesTeam = Url_Base + "EditErp6SaleBaseSalesTeam"
const Url_GetErp6SaleBaseSalesTeamList = Url_Base + "GetErp6SaleBaseSalesTeamList"
const Url_GetErp6SaleBaseSalesTeamNum = Url_Base + "GetErp6SaleBaseSalesTeamNum"
const Url_GetErp6SaleBaseSalesTeamListAll = Url_Base + "GetErp6SaleBaseSalesTeamListAll"
const Url_AddErp6SaleBaseSalesperson = Url_Base + "AddErp6SaleBaseSalesperson"
const Url_DelErp6SaleBaseSalesperson = Url_Base + "DelErp6SaleBaseSalesperson"
const Url_EditErp6SaleBaseSalesperson = Url_Base + "EditErp6SaleBaseSalesperson"
const Url_GetErp6SaleBaseSalespersonList = Url_Base + "GetErp6SaleBaseSalespersonList"
const Url_GetErp6SaleBaseSalespersonListAll = Url_Base + "GetErp6SaleBaseSalespersonListAll"
const Url_GetErp6SaleBaseSalespersonNum = Url_Base + "GetErp6SaleBaseSalespersonNum"
const Url_AddErp6SaleBaseCustomerInfo = Url_Base + "AddErp6SaleBaseCustomerInfo"
const Url_DelErp6SaleBaseCustomerInfo = Url_Base + "DelErp6SaleBaseCustomerInfo"
const Url_EditErp6SaleBaseCustomerInfo = Url_Base + "EditErp6SaleBaseCustomerInfo"
const Url_GetErp6SaleBaseCustomerInfoList = Url_Base + "GetErp6SaleBaseCustomerInfoList"
const Url_GetErp6SaleBaseCustomerInfoNum = Url_Base + "GetErp6SaleBaseCustomerInfoNum"
const Url_GetErp6SaleBaseCustomerInfoListBySalesManId = Url_Base + "GetErp6SaleBaseCustomerInfoListBySalesManId"
//预存管理
const Url_AddErp6SalePrepayment = Url_Base + "AddErp6SalePrepayment"
const Url_GetErp6SalePrepaymentList = Url_Base + "GetErp6SalePrepaymentList"
const Url_GetErp6SalePrepaymentNum = Url_Base + "GetErp6SalePrepaymentNum"
//销售订单
const Url_AddErp6SaleOrder = Url_Base + "AddErp6SaleOrder"
const Url_DelErp6SaleOrder = Url_Base + "DelErp6SaleOrder"
const Url_EditErp6SaleOrder = Url_Base + "EditErp6SaleOrder"
const Url_GetErp6SaleOrderNum = Url_Base + "GetErp6SaleOrderNum"
const Url_GetErp6SaleOrderList = Url_Base + "GetErp6SaleOrderList"
const Url_ShenPiErp6SaleOrder0 = Url_Base + "ShenPiErp6SaleOrder0"
const Url_ShenPiErp6SaleOrder1 = Url_Base + "ShenPiErp6SaleOrder1"
const Url_ShenPiErp6SaleOrder2 = Url_Base + "ShenPiErp6SaleOrder2"
const Url_ShenPiErp6SaleOrder3 = Url_Base + "ShenPiErp6SaleOrder3"
const Url_ShenPiErp6SaleOrder4 = Url_Base + "ShenPiErp6SaleOrder4"
//销售订单收款
const Url_AddErp6SaleCollection = Url_Base + "AddErp6SaleCollection"
const Url_GetErp6SaleCollectionList = Url_Base + "GetErp6SaleCollectionList"
const Url_GetErp6SaleCollectionNum = Url_Base + "GetErp6SaleCollectionNum"
//销售订单发货
const Url_AddErp6SaleShip = Url_Base + "AddErp6SaleShip"
const Url_GetErp6SaleShipList = Url_Base + "GetErp6SaleShipList"
const Url_GetErp6SaleShipNum = Url_Base + "GetErp6SaleShipNum"
//销售看板
const Url_Erp6SaleSignboard = Url_Base + "Erp6SaleSignboard"
//保修卡号查询表 20240716
const Url_GetErp6SnList = Url_Base + "GetErp6SnList"
const Url_GetErp6SnNum = Url_Base + "GetErp6SnNum"
const Url_DelErp6Sn = Url_Base + "DelErp6Sn"
////////////// 20240604 新增管理->库存管理
//入库管理
const Url_AddErp6InventoryIn = Url_Base + "AddErp6InventoryIn"
const Url_DelErp6InventoryIn = Url_Base + "DelErp6InventoryIn"
const Url_EditErp6InventoryIn = Url_Base + "EditErp6InventoryIn"
const Url_GetErp6InventoryInNum = Url_Base + "GetErp6InventoryInNum"
const Url_GetErp6InventoryInList = Url_Base + "GetErp6InventoryInList"
//出库管理
const Url_AddErp6InventoryOut = Url_Base + "AddErp6InventoryOut"
const Url_DelErp6InventoryOut = Url_Base + "DelErp6InventoryOut"
const Url_EditErp6InventoryOut = Url_Base + "EditErp6InventoryOut"
const Url_GetErp6InventoryOutNum = Url_Base + "GetErp6InventoryOutNum"
const Url_GetErp6InventoryOutList = Url_Base + "GetErp6InventoryOutList"
const Url_GetErp6InventoryRealTimeNum = Url_Base + "GetErp6InventoryRealTimeNum"
const Url_GetErp6InventoryRealTimeList = Url_Base + "GetErp6InventoryRealTimeList"
//库存明细
const Url_GetErp6InventoryMonthlyList = Url_Base + "GetErp6InventoryMonthlyList"
const Url_GetErp6InventoryMonthlyNum = Url_Base + "GetErp6InventoryMonthlyNum"
const Url_GetErp6InventoryDetailsList = Url_Base + "GetErp6InventoryDetailsList"
const Url_GetErp6InventoryDetailsNum = Url_Base + "GetErp6InventoryDetailsNum"
//库存管理看板
const Url_Erp6InventorySignboard = Url_Base + "Erp6InventorySignboard"
//20240518 后台视光分析
//基本信息
const Url_AddErp7ShiGuangJiBenXinXi = Url_Base + "AddErp7ShiGuangJiBenXinXi"
const Url_EditErp7ShiGuangJiBenXinXi = Url_Base + "EditErp7ShiGuangJiBenXinXi"
const Url_DelErp7ShiGuangJiBenXinXi = Url_Base + "DelErp7ShiGuangJiBenXinXi"
const Url_GetErp7ShiGuangJiBenXinXiList = Url_Base + "GetErp7ShiGuangJiBenXinXiList"
const Url_GetErp7ShiGuangJiBenXinXiNum = Url_Base + "GetErp7ShiGuangJiBenXinXiNum"
//验光检查档案
const Url_AddErp7ShiGuangYanGuangJianCha = Url_Base + "AddErp7ShiGuangYanGuangJianCha"
const Url_EditErp7ShiGuangYanGuangJianCha = Url_Base + "EditErp7ShiGuangYanGuangJianCha"
const Url_DelErp7ShiGuangYanGuangJianCha = Url_Base + "DelErp7ShiGuangYanGuangJianCha"
const Url_GetErp7ShiGuangYanGuangJianChaList = Url_Base + "GetErp7ShiGuangYanGuangJianChaList"
const Url_GetErp7ShiGuangYanGuangJianChaList2 = Url_Base + "GetErp7ShiGuangYanGuangJianChaList2"
const Url_GetErp7ShiGuangYanGuangJianChaNum = Url_Base + "GetErp7ShiGuangYanGuangJianChaNum"
const Url_GetErp7ShiGuangYanGuangJianChaSingle = Url_Base + "GetErp7ShiGuangYanGuangJianChaSingle"
//调节功能数据分析
const Url_AddErp7ShiGuangTiaoJieGongNeng = Url_Base + "AddErp7ShiGuangTiaoJieGongNeng"
const Url_EditErp7ShiGuangTiaoJieGongNeng = Url_Base + "EditErp7ShiGuangTiaoJieGongNeng"
const Url_DelErp7ShiGuangTiaoJieGongNeng = Url_Base + "DelErp7ShiGuangTiaoJieGongNeng"
const Url_GetErp7ShiGuangTiaoJieGongNengList = Url_Base + "GetErp7ShiGuangTiaoJieGongNengList"
const Url_GetErp7ShiGuangTiaoJieGongNengNum = Url_Base + "GetErp7ShiGuangTiaoJieGongNengNum"
//眼健康评估曲线图
const Url_AddErp7ShiGuangYanJianKangQuXian = Url_Base + "AddErp7ShiGuangYanJianKangQuXian"
const Url_EditErp7ShiGuangYanJianKangQuXian = Url_Base + "EditErp7ShiGuangYanJianKangQuXian"
const Url_DelErp7ShiGuangYanJianKangQuXian = Url_Base + "DelErp7ShiGuangYanJianKangQuXian"
const Url_GetErp7ShiGuangYanJianKangQuXianList = Url_Base + "GetErp7ShiGuangYanJianKangQuXianList"
const Url_GetErp7ShiGuangYanJianKangQuXianNum = Url_Base + "GetErp7ShiGuangYanJianKangQuXianNum"
//训练平板-ERP
const Url_AddTrainPadGameSort = Url_Base + "AddTrainPadGameSort"
const Url_EditTrainPadGameSort = Url_Base + "EditTrainPadGameSort"
const Url_DeleteTrainPadGameSort = Url_Base + "DeleteTrainPadGameSort"
const Url_GetTrainPadGameSortlist = Url_Base + "GetTrainPadGameSortlist"
const Url_AddTrainPadGameList = Url_Base + "AddTrainPadGameList"
const Url_EditTrainPadGameList = Url_Base + "EditTrainPadGameList"
const Url_DeleteTrainPadGameList = Url_Base + "DeleteTrainPadGameList"
const Url_GetTrainPadGameList = Url_Base + "GetTrainPadGameList"
const Url_GetTrainPadLogList = Url_Base + "GetTrainPadLogList"
const Url_GetTrainPadLogNum = Url_Base + "GetTrainPadLogNum"
const Url_GetTrainPadClickList = Url_Base + "GetTrainPadClickList"
const Url_GetTrainPadClickNum = Url_Base + "GetTrainPadClickNum"
const Url_GetTrainPadDayTongJiList = Url_Base + "GetTrainPadDayTongJiList"
const Url_GetTrainPadDayTongJiNum = Url_Base + "GetTrainPadDayTongJiNum"
//屈光参差变焦镜-设备管理
const Url_AddRefractiveDiscrepancyDevice = Url_Base + "AddRefractiveDiscrepancyDevice"
const Url_EditRefractiveDiscrepancyDevice = Url_Base + "EditRefractiveDiscrepancyDevice"
const Url_GetRefractiveDiscrepancyDeviceList = Url_Base + "GetRefractiveDiscrepancyDeviceList"
const Url_GetRefractiveDiscrepancyDeviceNum = Url_Base + "GetRefractiveDiscrepancyDeviceNum"
//屈光参差变焦镜-用户管理
const Url_AddRefractiveDiscrepancyUser = Url_Base + "AddRefractiveDiscrepancyUser"
const Url_EditRefractiveDiscrepancyUser = Url_Base + "EditRefractiveDiscrepancyUser"
const Url_GetRefractiveDiscrepancyUserList = Url_Base + "GetRefractiveDiscrepancyUserList"
const Url_GetRefractiveDiscrepancyUserNum = Url_Base + "GetRefractiveDiscrepancyUserNum"
//屈光参差变焦镜-用户复查管理
const Url_AddRefractiveDiscrepancyUserFuCha = Url_Base + "AddRefractiveDiscrepancyUserFuCha"
const Url_EditRefractiveDiscrepancyUserFuCha = Url_Base + "EditRefractiveDiscrepancyUserFuCha"
const Url_GetRefractiveDiscrepancyUserFuChaList = Url_Base + "GetRefractiveDiscrepancyUserFuChaList"
const Url_GetRefractiveDiscrepancyUserFuChaNum = Url_Base + "GetRefractiveDiscrepancyUserFuChaNum"
//屈光参差变焦镜-视力变化趋势图 H5
const Url_AnisoFocusListVisionTrend = Url_Base + "AnisoFocusListVisionTrend"
//豆迈科技-眼镜用户管理
const Url_DouMaiKeJiGlassuserGetList = Url_Base + "DouMaiKeJiGlassuserGetList"
const Url_DouMaiKeJiGlassuserGetNum = Url_Base + "DouMaiKeJiGlassuserGetNum"
const Url_DouMaiKeJiGlassuserNewSn = Url_Base + "DouMaiKeJiGlassuserNewSn"
const Url_DouMaiKeJiGlassuserAdd = Url_Base + "DouMaiKeJiGlassuserAdd"
const Url_DouMaiKeJiGlassuserUnbind = Url_Base + "DouMaiKeJiGlassuserUnbind"
const Url_DouMaiKeJiGlassuserOldSnGetList = Url_Base + "DouMaiKeJiGlassuserOldSnGetList"
const Url_DouMaiKeJiWxUserGetList = Url_Base + "DouMaiKeJiWxUserGetList"
const Url_DouMaiKeJiWxUserGetNum = Url_Base + "DouMaiKeJiWxUserGetNum"
const Url_DouMaiKeJiWxUserChangeYeWuYuan = Url_Base + "DouMaiKeJiWxUserChangeYeWuYuan"
//豆迈科技-用户复查管理
const Url_AddMiniProgramDouMaiKeJiUserFuCha = Url_Base + "AddMiniProgramDouMaiKeJiUserFuCha"
const Url_EditMiniProgramDouMaiKeJiUserFuCha = Url_Base + "EditMiniProgramDouMaiKeJiUserFuCha"
const Url_GetMiniProgramDouMaiKeJiUserFuChaList = Url_Base + "GetMiniProgramDouMaiKeJiUserFuChaList"
const Url_GetMiniProgramDouMaiKeJiUserFuChaNum = Url_Base + "GetMiniProgramDouMaiKeJiUserFuChaNum"
//豆迈科技-一周佩戴时长 H5
const Url_DouMaiKeJiShiChangTuBiao = Url_Base + "DouMaiKeJiShiChangTuBiao"
//门店进销存管理
//采购管理
const Url_AddMenDianPurchaseSalesJinXiao = Url_Base + "AddMenDianPurchaseSalesJinXiao"
const Url_DeleteMenDianPurchaseSalesJinXiao = Url_Base + "DeleteMenDianPurchaseSalesJinXiao"
const Url_EditMenDianPurchaseSalesJinXiao = Url_Base + "EditMenDianPurchaseSalesJinXiao"
const Url_GetMenDianPurchaseSalesJinXiaoList = Url_Base + "GetMenDianPurchaseSalesJinXiaoList"
const Url_GetMenDianPurchaseSalesJinXiaoNum = Url_Base + "GetMenDianPurchaseSalesJinXiaoNum"
//库存管理
const Url_MenDianPurchaseSalesKuCun = Url_Base + "MenDianPurchaseSalesKuCun"
const Url_MenDianPurchaseSalesKuCunNum = Url_Base + "MenDianPurchaseSalesKuCunNum"
//领用出库
const Url_AddMenDianPurchaseSalesKuCunOutUse = Url_Base + "AddMenDianPurchaseSalesKuCunOutUse"
const Url_DeleteMenDianPurchaseSalesKuCunOutUse = Url_Base + "DeleteMenDianPurchaseSalesKuCunOutUse"
const Url_GetMenDianPurchaseSalesKuCunOutUseList = Url_Base + "GetMenDianPurchaseSalesKuCunOutUseList"
//销售出库
const Url_AddMenDianPurchaseSalesKuCunOutSale = Url_Base + "AddMenDianPurchaseSalesKuCunOutSale"
const Url_DeleteMenDianPurchaseSalesKuCunOutSale = Url_Base + "DeleteMenDianPurchaseSalesKuCunOutSale"
const Url_GetMenDianPurchaseSalesKuCunOutSaleList = Url_Base + "GetMenDianPurchaseSalesKuCunOutSaleList"
//采购汇总
const Url_MenDianPurchaseSalesCaiGouHuiZong = Url_Base + "MenDianPurchaseSalesCaiGouHuiZong"
//销售汇总
const Url_MenDianPurchaseSalesXiaoShouHuiZong = Url_Base + "MenDianPurchaseSalesXiaoShouHuiZong"
//费用录入
const Url_AddMenDianPurchaseSalesFeiYongLuRu = Url_Base + "AddMenDianPurchaseSalesFeiYongLuRu"
const Url_DeleteMenDianPurchaseSalesFeiYongLuRu = Url_Base + "DeleteMenDianPurchaseSalesFeiYongLuRu"
const Url_EditMenDianPurchaseSalesFeiYongLuRu = Url_Base + "EditMenDianPurchaseSalesFeiYongLuRu"
const Url_GetMenDianPurchaseSalesFeiYongLuRuList = Url_Base + "GetMenDianPurchaseSalesFeiYongLuRuList"
const Url_GetMenDianPurchaseSalesFeiYongLuRuNum = Url_Base + "GetMenDianPurchaseSalesFeiYongLuRuNum"
//鹰瞳-眼底照相机
const Url_GetYingTongDeviceList = Url_Base + "GetYingTongDeviceList"
const Url_GetYingTongDeviceNum = Url_Base + "GetYingTongDeviceNum"
const Url_GetYingTongReportList = Url_Base + "GetYingTongReportList"
const Url_GetYingTongReportNum = Url_Base + "GetYingTongReportNum"
// 全局变量
const Gv_FromName = '睿世力控股集团'
const Gv_FromLogo = 'https://erp-1256233047.cos.ap-shanghai.myqcloud.com/static/4b0778b9-938f-98f7-0cc2-9512f2d15f13smalllogo.png'

export default {
	LocalFingerprint,
  Url_ErpLogin,
  Url_CheckLogin,
  Url_Addmenu,
  Url_Getallmenu,
  Url_Getonemenu,
  Url_Editonemenu,
  Url_Deleteonemenu,
  Url_Addrole,
  Url_Getallrole,
  Url_Editonerole,
  Url_Getrolepermissions,
  Url_Editrolepermissions,
  Url_Deleteonerole,
  Url_Getjigoutree,
  Url_Getjigoulist,
  Url_Getjigoutreesmall,
  Url_Getjigoutreeid,
  Url_Getregionlist,
  Url_Addjigou,
  Url_Editjigou,
  Url_Deletejigou,
  Url_Deletejigouforce,
  Url_Geterpusernum,
  Url_Geterpuserlist,
  Url_Adderpuser,
  Url_Editerpuser,
  Url_Editerpuserstaus,
  Url_Deleteerpuser,
  Url_Getspeedlist,
  Url_Editspeed,
  Url_Getloglist,
  Url_Getlognum,
  Url_GetlogTongJi,
  Url_Getfaceidloglist,
  Url_Getfaceidlognum,
  Url_Getversionlist,
  Url_Addversion,
  Url_Editversion,
  Url_Deleteversion,
  Url_Getprivatemenu,
  Url_Editselfpwd,
  Url_GetTencentyunCosSts,
  Url_Erpapidefault,
  Url_GetDlsOrderSubWithOrderid,
  Url_GetDlsOrderInfoWithOrderid,
  Url_Editproductinfo,
  Url_Deleteproductinfo,
  Url_Addproductmoney,
  Url_Getallproductmoneylist,
  Url_Getallproductmoneynum,
  Url_Editproductmoney,
  Url_Editproductmoneyshenhe,
  Url_Deleteproductmoney,
  Url_Getproductjiage,
  Url_Addproductorder,
  Url_Addproductorderbeizhu,
  Url_Addproductorderinvoice,
  Url_Editproductorder,
  Url_GenerateFuOrder,
  Url_Geterporderlist,
  Url_Geterporderlistsub,
  Url_DeleteErpOrder,
  Url_DeleteErpOrderInvoice,
  Url_Geterpordernum,
  Url_Geterporderinvoicelist,
  Url_Geterporderbeizhulist,
  Url_Editerporderpayimage,
  Url_Editerpordercaiwushenhe,
  Url_Editerpordercaiwuqishen,
  Url_Editerporderinvoicestatus,
  Url_Editerpordersubinvoicestatus,
  Url_Editerporderwuliu,
  Url_Editerporderreceipt,
  Url_Editerporderreceiptsimage,
  Url_GetSubRuleStaus,
  Url_Addproductsales,
  Url_Getproductsalesnum,
  Url_Getproductsaleslist,
  Url_Editproductsales,
  Url_Addmadeorder,
  Url_Getmadeordernum,
  Url_Getmadeorderlist,
  Url_Getmadeordernumkucun,
  Url_Getmadeorderlistkucun,
  Url_Editmadeordershenhe,
  Url_Editmadeordercancel,
  Url_Editmadeorderdelay,
  Url_Editmadeordertargetnum,
  Url_Editmadeordersubmitnum,
  Url_AddDlsReturnsHuan,
  Url_GetDlsReturnsHuannum,
  Url_GetDlsReturnsHuanlist,
  Url_EditDlsReturnsHuanshenhe,
  Url_EditDlsReturnsHuanSend,
  Url_EditDlsReturnsHuanSendOk,
  Url_EditDlsReturnsHuanReSend,
  Url_EditDlsReturnsHuanReSendOk,
  Url_AddDlsReturnsTui,
  Url_GetDlsReturnsTuinum,
  Url_GetDlsReturnsTuilist,
  Url_EditDlsReturnsTuishenhe,
  Url_EditDlsReturnsTuiSend,
  Url_EditDlsReturnsTuiSendOk,
  Url_Getproductinventorylist,
  Url_Getproductinventorynum,
  Url_Getallfinishedproductinventory,
  Url_Getcustomerlist,
  Url_Getcustomernum,
  Url_CheckCardnumber,
  Url_CheckCardnumberJigou,
  Url_Getpincode,
  Url_Addcustomer,
  Url_Getcustomerexcel,
  Url_Geterpfilenum,
  Url_Geterpfilelist,
  Url_Geterpimagenum,
  Url_DelErpImage,
  Url_Geterpimagelist,
  Url_GetRegisterEyeinfo,
  Url_EditRegisterEyeinfo,
  Url_Getcustomerinfo,
  Url_Editcustomeravatarurl,
  Url_Editcustomerbind,
  Url_Editcustomerunbind,
  Url_Editcustomerdelay,
  Url_Getcustomereditinfo,
  Url_Getglassuserchangeiplimit,
  Url_Editcustomereditinfo,
  Url_EditCustomerLoginName,
  Url_Getfuchalist,
  Url_Getfuchanum,
  Url_Addfucha,
  Url_Editfucha,
  Url_Getfuchalist2,
  Url_Getcustomerpause,
  Url_Getcustomerchangeuserlogin,
  Url_Addcustomerpause,
  Url_Forcedeletecustomer,
  Url_Getcustomeriplist,
  Url_Getcustomeripnum,
  Url_Getrenewallist,
  Url_Getrenewalnum,
  Url_Getrenewaltyjlist,
  Url_Getrenewaltyjnum,
  Url_Addrenewalorder,
  Url_Getcustomerlist2,
  Url_Getcustomernum2,
  Url_Getcustomerlist3,
  Url_Getcustomernum3,
  Url_Getcustomerruledata,
  Url_Editcustomerruledata,
  Url_GetDownDatalist,
  Url_GetDownDatanum,
  Url_GetCaijilist,
  Url_GetCaijinum,
  Url_GetSensorDatalist,
  Url_GetSensorDatanum,
  Url_GetDevicelist,
  Url_GetDevicePlLianglist,
  Url_GetDevicePlLiangnum,
  Url_ProcessDevicePlLiang,
  Url_GetDeviceSaleStatistical,
  Url_GetDevicenum,
  Url_AddDevice,
  Url_AddDevicePlLiang,
  Url_EditDevice,
  Url_EditDeviceUnbind,
  Url_EditDeviceJigou,
  Url_EditDeviceJigouPlLiang,
  Url_GetDeviceinfo,
  Url_GetDevicepause,
  Url_AddDevicepause,
  Url_ForceClearDevice,
  Url_GetDeviceMovelist,
  Url_GetDeviceMovenum,
  Url_GetChangeTypelist,
  Url_GetChangeTypenum,
  Url_GetDailyDatalist,
  Url_GetDailyDatanum,
  Url_GetGanyuHeJujian,
  Url_GetCaiJiTrend,
  Url_AnnualReportlist,
  Url_AnnualReportnum,
  Url_GetAnnualReportinfo,
  Url_WearingDayslist,
  Url_WearingDaysnum,
  Url_Feedbacklist,
  Url_Feedbacknum,
  Url_EditFeedback,
  Url_Qalist,
  Url_Qanum,
  Url_AddQa,
  Url_EditQa,
  Url_Caseslist,
  Url_Casesnum,
  Url_AddCases,
  Url_EditCases,
  Url_DeleteCases,
  Url_OptometryHalllist,
  Url_OptometryHallnum,
  Url_AddOptometryHall,
  Url_EditOptometryHall,
  Url_DeleteOptometryHall,
  Url_Newslist,
  Url_Newsnum,
  Url_AddNews,
  Url_EditNews,
  Url_DeleteNews,
  Url_GetHomePageData,
  Url_ExceptionReminderlist,
  Url_ExceptionRemindernum,
  Url_ImportantReminderlist,
  Url_ImportantRemindernum,
  Url_ReviewReminderlist,
  Url_ReviewRemindernum,
  Url_LastIntervalReminderlist,
  Url_LastIntervalRemindernum,
  Url_DeviceExceptionReminderlist,
  Url_DeviceExceptionRemindernum,
  Url_GetDeviceExceptionReminderProcess,
  Url_AddDeviceExceptionReminderProcess,
  Url_CustomerRenewalOrderlist,
  Url_CustomerRenewalOrdernum,
  Url_EditCustomerRenewalOrder,
  Url_CustomerRenewalOrderReport,
  Url_StoreOwnerlist,
  Url_StoreOwnernum,
  Url_AddStoreOwner,
  Url_EditStoreOwner,
  Url_StoreOwnerShareList,
  Url_StoreOwnerShareNum,
  Url_StoreOwnerTransferList,
  Url_StoreOwnerTransferNum,
  Url_WithdrawalApprovallist,
  Url_WithdrawalApprovalnum,
  Url_WithdrawalApprovalApplyOk,
  Url_WithdrawalApprovalApplyFail,
  Url_WithdrawalApprovalTransfer1,
  Url_WithdrawalApprovalTransfer2,
  Url_AddDlsReturnsXiu,
  Url_GetDlsReturnsXiunum,
  Url_GetDlsReturnsXiulist,
  Url_EditDlsReturnsXiushenhe,
  Url_EditDlsReturnsXiuSend,
  Url_EditDlsReturnsXiuSendOk,
  Url_EditDlsReturnsXiuReSend,
  Url_EditDlsReturnsXiuReSendOk,
  Url_ExcelExceptionReminder,
  Url_ExcelImportantReminder,
  Url_ExcelImportErp6Bom,
  Url_ExcelImportErp6ProjectName,
  Url_ExcelImportMenDianPurchaseSalesJinXiao,
  Url_ExcelImportErp6SupplierProfile,
  Url_ExcelImportErp6SaleBaseProductPrice,
  Url_ExcelImportErp6SaleBaseSalesTeam,
  Url_ExcelImportErp6SaleBaseSalesperson,
  Url_ExcelImportErp6SaleBaseCustomerInfo,
  Url_ExcelImportErp6SaleShip,
  Url_ExcelImportErp6Sn,
  Url_ExcelFuCha,
  Url_ExcelRenewal,
  Url_ExcelCaiji,
  Url_ExcelCaijiCompression,
  Url_ExcelDevice,
  Url_ExcelErp6ProjectName,
  Url_ExcelErp6Bom,
  Url_ExcelErp6SupplierProfile,
  Url_ExcelErp6SaleBaseProductPrice,
  Url_ExcelErp6SaleBaseSalesTeam,
  Url_ExcelErp6SaleBaseSalesperson,
  Url_ExcelErp6SaleBaseCustomerInfo,
  Url_ExcelErp6SaleShip,
  Url_ExcelErp6Sn,
  Url_ExcelErp6InventoryIn,
  Url_ExcelErp6InventoryOut,
  Url_ExcelRuiXiaoDiTuiPromoters,
  Url_ExcelDailyDetails,
  Url_ExcelDaily,
  Url_ExcelRuischoolscUser,
  Url_ExcelErpDlsOrder,
  Url_ExcelNaoxjStockSendDetial,
  Url_ExcelLogsTongJi,
  Url_ExcelMenDianPurchaseSalesKuCun,
  Url_ExcelMenDianPurchaseSalesCaiGouHuiZong,
  Url_ExcelMenDianPurchaseSalesXiaoShouHuiZong,
  Url_ExcelMenDianPurchaseSalesXiaoShouMingXi,
  Url_ExcelNaoxjStockSale,
  Url_ExcelNaoxjStockStock,
  Url_ExcelAnnualReport,
  Url_ExcelWearingDays,
  Url_ExcelImport,
  Url_ExcelImportDevice,
  Url_ExcelImportPersonpayroll,
  Url_ExcelImportProjectbom,
  Url_ExcelImportProductMoneyRd,
  Url_ExcelImportRuischoolscUser,
  Url_ExcelOptometristPrescriptions,
  Url_ExcelOptometristPrescriptionsList,
  Url_ExcelOptometristJinHuoXinXi,
  Url_ExcelSingleDiopter,
  Url_ExcelDeviceSaleStatistical,
  Url_ExcelProjectbom,
  Url_ExcelProductMoneySupplier,
  Url_ExcelOptometristInventory,
  Url_ExcelYanYunDongOrderProduct,
  Url_ExcelRuiShiLiGouWuOrderProduct,
  Url_ExcelErpDlsLogErpLogin,
  Url_ExcelYingTongDevice,
  Url_ZipFileRuischoolscUser,
  Url_Getweixiutype,
  Url_GetYunYingShangKuCun,
  Url_GetYunYingShangSalesDetail,
  Url_GetYunYingShangSalesDetailExcel,
  Url_GetPaymentAccount,
  Url_ListBomsn,
  //ERP2
  Url_AddCaiWuReport,
  Url_EditCaiWuReport,
  Url_GetCaiWuReportList,
  Url_GetCaiWuReportNum,
  //审批费用报销&差旅费报销&采购付款
  Url_AddShenPiNewFyBxChaiLv1,
  Url_AddShenPiNewFyBxChaiLv2,
  Url_AddShenPiNewFyBxChaiLv3,
  Url_AddShenPiNewFyBxChaiLv4,
  Url_CheckCaiGouOrderid,
  Url_DelShenPiNewFyBxChaiLv,
  Url_EditShenPiNewFyBxChaiLv1,
  Url_EditShenPiNewFyBxChaiLv2,
  Url_EditShenPiNewFyBxChaiLv3,
  Url_EditShenPiNewFyBxChaiLv4,
  Url_GetShenPiNewFyBxChaiLvList,
  Url_GetShenPiNewFyBxChaiLvLogList,
  Url_GetShenPiNewFyBxChaiLvNum,
  Url_GetShenPiNewFyBxChaiLvSubList,
  Url_ShenPiNewFyBxChaiLvPrint,
  Url_ShenPiNewFyBxChaiLvSH0,
  Url_ShenPiNewFyBxChaiLvSH1,
  Url_ShenPiNewFyBxChaiLvSH2,
  Url_ShenPiNewFyBxChaiLvSH3,
  Url_ShenPiNewFyBxChaiLvSH4,
  Url_ShenPiTongJi,
  //审核报销
  Url_AddShenPiBaoXiao,
  Url_DelShenPiBaoXiao,
  Url_GetShenPiBaoXiaoList,
  Url_GetShenPiBaoXiaoNum,
  Url_ShenPiBaoXiaoSH1,
  Url_ShenPiBaoXiaoSH2,
  Url_ShenPiBaoXiaoSH3,
  Url_ShenPiBaoXiaoSH4,
  Url_ChangeBaoXiaoPayStatus,
  //审核费用
  Url_AddShenPiFeiYong,
  Url_DelShenPiFeiYong,
  Url_GetShenPiFeiYongList,
  Url_GetShenPiFeiYongNum,
  Url_ShenPiFeiYongSH1,
  Url_ShenPiFeiYongSH2,
  Url_ShenPiFeiYongSH3,
  Url_ShenPiFeiYongSH4,
  Url_ChangeFeiYongPayStatus,
  //审核用章
  Url_AddShenPiYongZhang,
  Url_DelShenPiYongZhang,
  Url_GetShenPiYongZhangList,
  Url_GetShenPiYongZhangNum,
  Url_ShenPiYongZhangSH1,
  Url_ShenPiYongZhangSH2,
  //审核请假
  Url_AddShenPiQingJia,
  Url_DelShenPiQingJia,
  Url_EditShenPiQingJia,
  Url_GetShenPiQingJiaList,
  Url_GetShenPiQingJiaNum,
  Url_ShenPiQingJiaSH1,
  Url_ShenPiQingJiaSH2,
  Url_ShenPiQingJiaSH3,
  //审核出差
  Url_AddShenPiChuChai,
  Url_DelShenPiChuChai,
  Url_GetShenPiChuChaiList,
  Url_GetShenPiChuChaiNum,
  Url_ShenPiChuChaiSH1,
  Url_ShenPiChuChaiSH2,
  Url_ShenPiChuChaiSH3,
  //审核招聘
  Url_AddShenPiZhaoPin,
  Url_DelShenPiZhaoPin,
  Url_GetShenPiZhaoPinList,
  Url_GetShenPiZhaoPinNum,
  Url_ShenPiZhaoPinSH1,
  Url_ShenPiZhaoPinSH2,
  Url_ShenPiZhaoPinSH3,
  //审核办公用品
  Url_AddShenPiBanGongYongPing,
  Url_DelShenPiBanGongYongPing,
  Url_GetShenPiBanGongYongPingList,
  Url_GetShenPiBanGongYongPingNum,
  Url_ShenPiBanGongYongPingSH1,
  Url_ShenPiBanGongYongPingSH2,
  Url_ChangeBanGongYongPingBuyStatus,
  //审核创建机构
  Url_AddShenPiJiGou,
  Url_EditShenPiJiGou,
  Url_DelShenPiJiGou,
  Url_GetShenPiJiGouList,
  Url_GetShenPiJiGouNum,
  Url_ShenPiJiGouSH1,
  Url_ShenPiJiGouSH2,
  Url_AddShenPiJiGouModify,
  Url_DelShenPiJiGouModify,
  Url_GetShenPiJiGouModifyList,
  Url_ShenPiJiGouModifySH1,
  Url_ShenPiJiGouModifySH2,
  //文件
  Url_AddErp3File,
  Url_DelErp3File,
  Url_GetErp3FileList,
  Url_GetErp3FileNum,
  Url_EditErp3File,
  Url_GetErp3FileList40,
  Url_GetErp3FileNum40,
  //员工生日
  Url_AddErp3StaffBirthday,
  Url_EditErp3StaffBirthday,
  Url_GetErp3StaffBirthdayList,
  Url_GetErp3StaffBirthdayNum,
  Url_GetErp3StaffBirthdayRecentlyList,
  //节日福利
  Url_AddErp3Holiday,
  Url_EditErp3Holiday,
  Url_GetErp3HolidayList,
  Url_GetErp3HolidayNum,
  Url_GetErp3HolidayRecentlyList,
  //微信商城
  Url_GetWxstoreUserList,
  Url_GetWxstoreUserNum,
  Url_GetWxstoreGoodsList,
  Url_GetWxstoreGoodsNum,
  Url_GetWxstoreSpeciesList,
  Url_AddWxstoreGoods,
  Url_EditWxstoreGoods,
  Url_ShangXiaJiaWxstoreGoods,
  Url_GetWxstoreOrderList,
  Url_GetWxstoreOrderNum,
  Url_FaHuoWxstoreOrder,
  //反馈单
  Url_GetFanKuiDanList,
  Url_GetFanKuiDanNum,
  Url_AddFanKuiDan,
  //协议模板
  Url_GetAgreementTemplateList,
  Url_GetAgreementTemplateNum,
  //协议备份
  Url_GetAgreementBackupList,
  Url_GetAgreementBackupNum,
  Url_AddAgreementBackup,
  //消息中心
  Url_GetMessageCenterUnreadList,
  Url_GetMessageCenterAllList,
  Url_GetMessageCenterAllNum,
  Url_AddMessageCenter,
  Url_CheckErpuser,
  //库存操作
  Url_Addmadeorderkucun,
  Url_Getmadeorderkucun,
  Url_DeleteMadeOrderKucun,
  //工作台
  Url_Geterpuserneibulist,
  Url_GetWorkbenchsingleList,
  Url_GetWorkbenchsingleNum,
  Url_AddWorkbenchsingle,
  Url_DeleteWorkbenchsingle,
  Url_PostWorkbenchsingleProgress,
  Url_GetWorkbenchLogreportList,
  Url_GetWorkbenchStatisticalList,
  Url_GetWorkbenchStatisticalNum,
  Url_DeleteWorkbenchStatistical,
  Url_PostWorkbenchStatisticalValuation,
  //部门预决算
  Url_AddWorkdepartmentbudget,
  Url_GetWorkdepartmentbudgetList,
  Url_GetWorkdepartmentbudgetNum,
  Url_EditWorkdepartmentbudget,
  Url_DeleteWorkdepartmentbudget,
  //部门预决算统计
  Url_GetWorkdepartmentbudgetstatisticalList,
  Url_GetWorkdepartmentbudgetstatisticalNum,
  //项目预决算
  Url_AddWorkprojectbudget,
  Url_GetWorkprojectbudgetList,
  Url_GetWorkprojectbudgetNum,
  Url_EditWorkprojectbudget,
  Url_DeleteWorkprojectbudget,
  Url_GetWorkprojectList,
  //项目预决算统计
  Url_GetWorkprojectbudgetstatisticalList,
  Url_GetWorkprojectbudgetstatisticalNum,
  //访客登记
  Url_AddVisitorslog,
  Url_GetVisitorslogList,
  Url_GetVisitorslogNum,
  Url_DelVisitorslog,
  //微盘
  Url_AddMicroDiskFile,
  Url_AddMicroDiskPermissions,
  Url_DelMicroDiskFile,
  Url_GetMicroDiskFileList,
  Url_MoveMicroDiskFile,
  Url_RenameMicroDiskFile,
  //BOM
  Url_AddProjectbom,
  Url_AddProjectbomMain,
  Url_DelProjectbom,
  Url_EditProjectbom,
  Url_Projectbomlist,
  Url_Projectbomnum,
  Url_CheckProjectbom,
  //供应商价格档案
  Url_Addproductmoneysupplier,
  Url_Deleteproductmoneysupplier,
  Url_Editproductmoneysupplier,
  Url_Editproductmoneysuppliershenhe,
  Url_Getproductmoneysupplierlist,
  Url_Getproductmoneysuppliernum,
  Url_Checkproductmoneysupplier,
  //研发专用价格档案
  Url_Addproductmoneyrd,
  Url_Deleteproductmoneyrd,
  Url_Editproductmoneyrd,
  Url_Editproductmoneyrdshenhe,
  Url_Getproductmoneyrdlist,
  Url_Getproductmoneyrdnum,
  //研发专用价格档案
  Url_AddPersonpayroll,
  Url_DelPersonpayroll,
  Url_EditPersonpayroll,
  Url_Personpayrolllist,
  Url_Personpayrollnum,
  //ERP项目成本核算
  Url_EditProjectcost,
  Url_Projectcostlist,
  //ERP新利润表
  Url_AddLiRunBiao,
  Url_ErpLiRunBiaoList,
  //ERP新现金日报
  Url_AddXianjinribao,
  Url_Xianjinribaolist,
  //部门费用汇总表
  Url_BumenfeiyonghuizongbiaoList,
  //不良品库存管理
  Url_Addmadedefectiveproductkucun,
  Url_Getmadedefectiveproductkucunlist,
  Url_Getmadedefectiveproductkucunnum,
  //
  Url_GetReportYunyingshangSales,
  //全国门店信息汇总表
  Url_AddGlassJigouInformation,
  Url_EditGlassJigouInformation,
  Url_ExcelImportGlassJigouInformation,
  Url_GetGlassJigouInformationList,
  Url_GetGlassJigouInformationNum,
  Url_GetGlassJigouSaleStatisticalList,
  //
  Url_AddDeviceClearPlLiang,
  Url_GetDeviceClearPlLianglist,
  Url_GetDeviceClearPlLiangnum,
  Url_ProcessDeviceClearPlLiang,
  //小睿智能筛查管家
  Url_GetMiniappShaichaWxuserList,
  Url_GetMiniappShaichaWxuserNum,
  Url_SetMiniappShaichaWxuser,
  Url_GetMiniappShaichaWxuserListSub,
  Url_GetMiniappShaichaVisionScreeningUserList,
  Url_GetMiniappShaichaVisionScreeningUserNum,
  Url_GetMiniappShaichaVisionScreeningUserListSub,
  Url_AddMiniappShaichaVisionScreeningUser,
  Url_AddMiniappShaichaStore,
  Url_DelMiniappShaichaStore,
  Url_EditMiniappShaichaStore,
  Url_GetMiniappShaichaStoreList,
  Url_GetMiniappShaichaStoreNum,
  //RSL-PT
  Url_AmapDirectionWalking,
  Url_BmapDirectionWalking,
  Url_Find100RSLPT,
  Url_BmapRslptLog,
  Url_GetNavMessage,
  //睿世力控股集团有限公司-ERP
  Url_GetKgjtWebsiteErpProductList,
  Url_GetKgjtWebsiteErpProductNum,
  Url_AddKgjtWebsiteErpProduct,
  Url_EditKgjtWebsiteErpProduct,
  Url_DelKgjtWebsiteErpProduct,
  Url_GetKgjtWebsiteErpProductCharacteristicsList,
  Url_GetKgjtWebsiteErpProductCharacteristicsNum,
  Url_AddKgjtWebsiteErpProductCharacteristics,
  Url_EditKgjtWebsiteErpProductCharacteristics,
  Url_DelKgjtWebsiteErpProductCharacteristics,
  Url_GetKgjtWebsiteErpProductColorList,
  Url_GetKgjtWebsiteErpProductColorNum,
  Url_AddKgjtWebsiteErpProductColor,
  Url_EditKgjtWebsiteErpProductColor,
  Url_DelKgjtWebsiteErpProductColor,
  Url_GetKgjtWebsiteErpProductInfoList,
  Url_GetKgjtWebsiteErpProductInfoNum,
  Url_AddKgjtWebsiteErpProductInfo,
  Url_EditKgjtWebsiteErpProductInfo,
  Url_DelKgjtWebsiteErpProductInfo,
  Url_GetKgjtWebsiteOfflineOrderList,
  Url_GetKgjtWebsiteOfflineOrderNum,
  Url_EditKgjtWebsiteOfflineOrderSubStatus,
  Url_AddKgjtWebsiteOfflineOrderSend,
  Url_DelKgjtWebsiteOfflineOrderSend,
  Url_EditKgjtWebsiteOfflineOrderSend,
  Url_GetKgjtWebsiteOfflineOrderSendList,
  Url_GetKgjtWebsiteOfflineOrderSendNum,
  Url_AddKgjtWebsiteOfflineOrderInvoice,
  Url_DelKgjtWebsiteOfflineOrderInvoice,
  Url_EditKgjtWebsiteOfflineOrderInvoice,
  Url_GetKgjtWebsiteOfflineOrderInvoiceList,
  Url_GetKgjtWebsiteOfflineOrderInvoiceNum,
  Url_AddKgjtWebsiteAnnouncement,
  Url_EditKgjtWebsiteAnnouncement,
  Url_DelKgjtWebsiteAnnouncement,
  Url_GetKgjtWebsiteAnnouncementList,
  Url_GetKgjtWebsiteAnnouncementNum,
  Url_GetKgjtWebsiteBodyCheckList,
  Url_GetKgjtWebsiteBodyCheckNum,
  Url_AddKgjtWebsiteProductEvolution,
  Url_EditKgjtWebsiteProductEvolution,
  Url_DelKgjtWebsiteProductEvolution,
  Url_GetKgjtWebsiteProductEvolutionList,
  Url_GetKgjtWebsiteProductEvolutionNum,
  Url_AddKgjtWebsiteNews,
  Url_EditKgjtWebsiteNews,
  Url_DelKgjtWebsiteNews,
  Url_GetKgjtWebsiteNewsList,
  Url_GetKgjtWebsiteNewsNum,
  Url_AddKgjtWebsiteNewsPic,
  Url_EditKgjtWebsiteNewsPic,
  Url_DelKgjtWebsiteNewsPic,
  Url_GetKgjtWebsiteNewsPicList,
  Url_GetKgjtWebsiteNewsPicNum,
  Url_AddKgjtWebsiteLearnVideo,
  Url_EditKgjtWebsiteLearnVideo,
  Url_DelKgjtWebsiteLearnVideo,
  Url_GetKgjtWebsiteLearnVideoList,
  Url_GetKgjtWebsiteLearnVideoNum,
  Url_GetKgjtWebsiteConsultingList,
  Url_GetKgjtWebsiteConsultingNum,
  Url_GetKgjtWebsiteOnlineMessageList,
  Url_GetKgjtWebsiteOnlineMessageNum,
  Url_AddKgjtWebsiteGeneralInformation,
  Url_EditKgjtWebsiteGeneralInformation,
  Url_DelKgjtWebsiteGeneralInformation,
  Url_GetKgjtWebsiteGeneralInformationList,
  Url_GetKgjtWebsiteGeneralInformationNum,
  Url_AddKgjtWebsiteHonor,
  Url_EditKgjtWebsiteHonor,
  Url_DelKgjtWebsiteHonor,
  Url_GetKgjtWebsiteHonorList,
  Url_GetKgjtWebsiteHonorNum,
  Url_AddKgjtWebsiteExperts,
  Url_EditKgjtWebsiteExperts,
  Url_DelKgjtWebsiteExperts,
  Url_GetKgjtWebsiteExpertsList,
  Url_GetKgjtWebsiteExpertsNum,
  Url_AddKgjtWebsiteExpertsInfo,
  Url_EditKgjtWebsiteExpertsInfo,
  Url_DelKgjtWebsiteExpertsInfo,
  Url_GetKgjtWebsiteExpertsInfoList,
  Url_GetKgjtWebsiteExpertsInfoNum,
  Url_AddKgjtWebsiteTalentStrategy,
  Url_EditKgjtWebsiteTalentStrategy,
  Url_DelKgjtWebsiteTalentStrategy,
  Url_GetKgjtWebsiteTalentStrategyList,
  Url_GetKgjtWebsiteTalentStrategyNum,
  Url_GetKgjtWebsiteSubsidiaryCompanyList,
  Url_GetKgjtWebsiteSubsidiaryCompanyNum,
  Url_EditKgjtWebsiteSubsidiaryCompany,
  Url_AddKgjtWebsiteProductRecommend,
  Url_EditKgjtWebsiteProductRecommend,
  Url_DelKgjtWebsiteProductRecommend,
  Url_GetKgjtWebsiteProductRecommendList,
  Url_GetKgjtWebsiteProductRecommendNum,
  // 20220728 获取当前用户的所有账号
  Url_SystemSetAdminsGetMyAcounts,
  //
  Url_AuxiliaryToolWorkWeixinMessageText,
  // 小睿地推
  Url_AddMiniAppRuiDiTuiActivity,
  Url_EditMiniAppRuiDiTuiActivity,
  Url_GetMiniAppRuiDiTuiActivityList,
  Url_GetMiniAppRuiDiTuiActivityNum,
  Url_AddMiniAppRuiDiTuiPromoters,
  Url_EditMiniAppRuiDiTuiPromoters,
  Url_GetMiniAppRuiDiTuiPromotersList,
  Url_GetMiniAppRuiDiTuiPromotersNum,
  Url_GetMiniAppRuiDiTuiExperienceList,
  Url_GetMiniAppRuiDiTuiExperienceNum,
  // RSL-EV
  Url_RslEvLogin,
  Url_RslEvCheckLogin,
  Url_RslEvGetUser,
  Url_RslEvAddUser,
  Url_RslEvAddCpuId,
  Url_RslEvBindGlassAndUser,
  Url_RslEvAddCpuIdTime,
  Url_RslEvPostSetDiopterLog,
  Url_GetRslEvUserList,
  Url_GetRslEvUserNum,
  Url_GetRslEvFuChaList,
  Url_GetRslEvFuChaNum,
  Url_AddRslEvFuCha,
  Url_EditRslEvFuCha,
  // 校园视力筛查系统
  Url_AddRuischoolscUser,
  Url_DelRuischoolscUser,
  Url_EditRuischoolscUser,
  Url_GetRuischoolscDushuList,
  Url_GetRuischoolscUserList,
  Url_GetRuischoolscUserNum,
  // 配镜-预付款
  Url_AddOptometristYuFuKuan,
  Url_OptometristYuFuKuanlist,
  Url_OptometristYuFuKuannum,
  // 配镜-预付款入账明细
  Url_OptometristYuFuKuanInList,
  Url_OptometristYuFuKuanInNum,
  // 配镜-预付款支出明细
  Url_OptometristYuFuKuanOutList,
  Url_OptometristYuFuKuanOutNum,
  // 配镜-处方单
  Url_AddOptometristPrescriptions,
  Url_DelOptometristPrescriptions,
  Url_EditOptometristPrescriptions,
  Url_GetOptometristPrescriptionsInfo,
  Url_GetOptometristPrescriptionsLastAddress,
  Url_GetOptometristPrescriptionsList,
  Url_GetOptometristPrescriptionsNum,
  Url_GetOptometristProcessCost,
  Url_GetOptometristInsurance,
  Url_GetOptometristUrgentFee,
  Url_SendOptometristPrescriptions,
  Url_ConfirmGoodsOptometristPrescriptions,
  Url_NoOnlinePayOptometristPrescriptions,
  // 配镜-分类
  Url_GetOptometristSuppliersClassification,
  // 配镜-进货
  Url_GetOptometristProductinPrice,
  Url_AddOptometristProductin,
  Url_DelOptometristProductin,
  Url_EditOptometristProductin,
  Url_GetOptometristProductinList,
  Url_GetOptometristProductinNum,
  // 配镜-出货
  Url_AddOptometristProductout,
  Url_DelOptometristProductout,
  Url_EditOptometristProductout,
  Url_GetOptometristProductoutList,
  Url_GetOptometristProductoutNum,
  Url_ConfirmGoodsOptometristProductout,
  // 配镜-订单
  Url_EditOptometristOrder,
  Url_GetOptometristOrderList,
  Url_GetOptometristOrderNum,
  // 配镜-库存
  Url_GetOptometristSuppliersList,
  Url_GetOptometristSuppliersNum,
  Url_EditOptometristSuppliersSpike,
  Url_EditOptometristSuppliersInfo,
  Url_EditOptometristSuppliersProcessCost,
  Url_EditOptometristSuppliersInsurance,
  //批量下架
  Url_PiLiangXiaJiaOptometristSuppliers,
  // 配镜-套餐组合
  Url_AddOptometristPackage,
  Url_DelOptometristPackage,
  Url_EditOptometristPackage,
  Url_GetOptometristPackageList,
  Url_GetOptometristPackageNum,
  // 配镜-微信用户
  Url_GetOptometristWxUserList,
  Url_GetOptometristWxUserNum,
  // 自动问答
  Url_AddAutoQaMain,
  Url_DelAutoQaMain,
  Url_EditAutoQaMain,
  Url_GetAutoQaMainList,
  Url_GetAutoQaMainNum,
  // 自动问答日志
  Url_GetAutoQaLogList,
  Url_GetAutoQaLogNum,
  // 可以给所有用户使用的接口
  Url_DiopterStateCalculator,
  // 提现审批
  Url_WithdrawalMonthlyStatistics,
  // 登录
  Url_GetLogErpLoginList,
  Url_GetLogErpLoginNum,
  // RSL-EV设备管理
  Url_GetRslEvDeviceList,
  Url_GetRslEvDeviceNum,
  Url_GetRslEvCpuidTimeList,
  Url_GetRslEvCpuidTimeNum,
  Url_GetRslevCpuidSetdiopterList,
  Url_GetRslevCpuidSetdiopterNum,
  Url_GetRslEvUserTimeList,
  Url_GetRslEvUserTimeNum,
  // RSL-EV用户管理
  Url_RuiYunGetRslEvUserList,
  Url_RuiYunGetRslEvUserNum,
  Url_RuiYunGetRslEvFuChaList,
  Url_RuiYunGetRslEvFuChaNum,
  Url_RuiYunAddRslEvFuCha,
  Url_RuiYunEditRslEvFuCha,
  // 训练软件
  Url_GetXunLianUsersList,
  Url_GetXunLianUsersNum,
  Url_EditXunLianUsers,
  Url_GetXunLianUsersPermissions,
  Url_EditXunLianUsersPermissions,
  // IP地址库
  Url_GetIpAddressList,
  Url_GetIpAddressNum,
  Url_EditIpAddress,
  // 广州睿眼进销存 产品目录
  Url_AddNaoxjStockCatalog,
  Url_EditNaoxjStockCatalog,
  Url_GetNaoxjStockCataloglist,
  Url_GetNaoxjStockCatalognum,
  Url_GetNaoxjStockCatalogNameList,
  Url_GetNaoxjStockCatalogBeizhuoutList,
  // 广州睿眼进销存 进货
  Url_AddNaoxjStockStock,
  Url_EditNaoxjStockStock,
  Url_GetNaoxjStockStocklist,
  Url_GetNaoxjStockStocknum,
  //广州睿眼进销存 销售
  Url_GetNaoxjStockSaleJiaGe,
  Url_AddNaoxjStockSale,
  Url_GetNaoxjStockSalelist,
  Url_GetNaoxjStockSalenum,
  Url_DeleteNaoxjStockSale,
  Url_GetNaoxjStockSaleByOrderid,
  Url_EditNaoxjStockSale,
  Url_EditNaoxjStockSaleSn,
  Url_GetNaoxjStockSaleSubByOrderid,
  Url_AddNaoxjStockSaleSend,
  Url_DeleteNaoxjStockSaleSend,
  Url_GetNaoxjStockSaleSendlist,
  Url_CaiWuShenPiNaoxjStockSale,
  //广州睿眼进销存 库存
  Url_NaoxjStockInventoryList,
  //广州睿眼进销存 统计品类
  Url_NaoxjStockStatisticsCategoryList,
  Url_NaoxjStockStatisticsSalesmanList,
  Url_NaoxjStockStatisticsClientList,
  //派视明-登录
  Url_ThirdPsmLogin,
  Url_ThirdPsmCheckLogin,
  //派视明-机构管理
  Url_AddThirdPsmJiGou,
  Url_EditThirdPsmJiGou,
  Url_GetThirdPsmJiGouList,
  Url_GetThirdPsmJiGouNum,
  //广州睿眼-眼运动-ERP
  Url_YanYunDongProductsAdd,
  Url_YanYunDongProductsEdit,
  Url_YanYunDongProductsGetList,
  Url_YanYunDongProductsGetNum,
  Url_YanYunDongProductsShangXiaJia,
  Url_YanYunDongOrderProductGetList,
  Url_YanYunDongOrderProductGetNum,
  Url_YanYunDongOrderProductEdit,
  Url_YanYunDongOrderYearlyPaymentGetList,
  Url_YanYunDongOrderYearlyPaymentGetNum,
  Url_YanYunDongOrderUnlockDegreeGetList,
  Url_YanYunDongOrderUnlockDegreeGetNum,
  Url_YanYunDongWxUserGetList,
  Url_YanYunDongWxUserGetNum,
  Url_YanYunDongWxUserChangeYeWuYuan,
  Url_YanYunDongGlassuserGetList,
  Url_YanYunDongGlassuserGetNum,
  Url_YanYunDongGlassuserNewSn,
  Url_YanYunDongGlassuserAdd,
  Url_YanYunDongGlassuserUnbind,
  Url_YanYunDongGlassuserOldSnGetList,
  //广州睿眼-睿世力购物-ERP
  Url_RuiShiLiGouWuProductsAdd,
  Url_RuiShiLiGouWuProductsEdit,
  Url_RuiShiLiGouWuProductsGetList,
  Url_RuiShiLiGouWuProductsGetNum,
  Url_RuiShiLiGouWuProductsShangXiaJia,
  Url_RuiShiLiGouWuOrderProductGetList,
  Url_RuiShiLiGouWuOrderProductGetNum,
  Url_RuiShiLiGouWuOrderProductEdit,
  Url_RuiShiLiGouWuOrderYearlyPaymentGetList,
  Url_RuiShiLiGouWuOrderYearlyPaymentGetNum,
  Url_RuiShiLiGouWuOrderUnlockDegreeGetList,
  Url_RuiShiLiGouWuOrderUnlockDegreeGetNum,
  Url_RuiShiLiGouWuWxUserGetList,
  Url_RuiShiLiGouWuWxUserGetNum,
  Url_RuiShiLiGouWuWxUserChangeYeWuYuan,
  Url_RuiShiLiGouWuGlassuserGetList,
  Url_RuiShiLiGouWuGlassuserGetNum,
  Url_RuiShiLiGouWuGlassuserNewSn,
  Url_RuiShiLiGouWuGlassuserAdd,
  Url_RuiShiLiGouWuGlassuserUnbind,
  Url_RuiShiLiGouWuGlassuserOldSnGetList,
  // 20240401 新增管理->采购管理
  Url_GetErp6ProjectNameList,
  Url_GetErp6BomList,
  Url_GetErp6BomDanCaiList,
  Url_GetErp6SupplierProfileList,
  Url_GetErp6SupplierProfileListByCode,
  Url_AddErp6PurchaseOrder,
  Url_GetErp6PurchaseOrderNum,
  Url_GetErp6PurchaseOrderList,
  Url_DelErp6PurchaseOrder,
  Url_EditErp6PurchaseOrder,
  Url_ShenPiErp6PurchaseOrder0,
  Url_ShenPiErp6PurchaseOrder1,
  Url_ShenPiErp6PurchaseOrder2,
  Url_ShenPiErp6PurchaseOrder3,
  Url_ShenPiErp6PurchaseOrder4,
  Url_AddErp6PurchaseOrderFuKuanShenHe,
  Url_DelErp6PurchaseOrderFuKuanShenHe,
  Url_EditErp6PurchaseOrderFuKuanShenHe,
  Url_GetErp6PurchaseOrderFuKuanShenHeNum,
  Url_GetErp6PurchaseOrderFuKuanShenHeList,
  Url_ShenPiErp6PurchaseOrderFuKuanShenHe0,
  Url_ShenPiErp6PurchaseOrderFuKuanShenHe1,
  Url_ShenPiErp6PurchaseOrderFuKuanShenHe2,
  Url_ShenPiErp6PurchaseOrderFuKuanShenHe3,
  Url_ShenPiErp6PurchaseOrderFuKuanShenHeChuNa,
  Url_AddErp6PurchaseOrderDelivery,
  Url_GetErp6PurchaseOrderDeliveryNum,
  Url_GetErp6PurchaseOrderDeliveryList,
  Url_Erp6PurchaseOrderSignboard,
  // 20240423 新增管理->销售管理
  Url_AddErp6SaleBaseProductPrice,
  Url_DelErp6SaleBaseProductPrice,
  Url_EditErp6SaleBaseProductPrice,
  Url_GetErp6SaleBaseProductPriceList,
  Url_GetErp6SaleBaseProductPriceNum,
  Url_GetErp6SaleBaseProductPriceByProjectcode,
  Url_AddErp6SaleBaseSalesTeam,
  Url_DelErp6SaleBaseSalesTeam,
  Url_EditErp6SaleBaseSalesTeam,
  Url_GetErp6SaleBaseSalesTeamList,
  Url_GetErp6SaleBaseSalesTeamNum,
  Url_GetErp6SaleBaseSalesTeamListAll,
  Url_AddErp6SaleBaseSalesperson,
  Url_DelErp6SaleBaseSalesperson,
  Url_EditErp6SaleBaseSalesperson,
  Url_GetErp6SaleBaseSalespersonList,
  Url_GetErp6SaleBaseSalespersonListAll,
  Url_GetErp6SaleBaseSalespersonNum,
  Url_AddErp6SaleBaseCustomerInfo,
  Url_DelErp6SaleBaseCustomerInfo,
  Url_EditErp6SaleBaseCustomerInfo,
  Url_GetErp6SaleBaseCustomerInfoList,
  Url_GetErp6SaleBaseCustomerInfoNum,
  Url_GetErp6SaleBaseCustomerInfoListBySalesManId,
  //预存管理
  Url_AddErp6SalePrepayment,
  Url_GetErp6SalePrepaymentList,
  Url_GetErp6SalePrepaymentNum,
  //销售订单
  Url_AddErp6SaleOrder,
  Url_DelErp6SaleOrder,
  Url_EditErp6SaleOrder,
  Url_GetErp6SaleOrderNum,
  Url_GetErp6SaleOrderList,
  Url_ShenPiErp6SaleOrder0,
  Url_ShenPiErp6SaleOrder1,
  Url_ShenPiErp6SaleOrder2,
  Url_ShenPiErp6SaleOrder3,
  Url_ShenPiErp6SaleOrder4,
  //销售订单收款
  Url_AddErp6SaleCollection,
  Url_GetErp6SaleCollectionList,
  Url_GetErp6SaleCollectionNum,
  //销售订单发货
  Url_AddErp6SaleShip,
  Url_GetErp6SaleShipList,
  Url_GetErp6SaleShipNum,
  //销售看板
  Url_Erp6SaleSignboard,
  //保修卡号查询表 20240716
  Url_GetErp6SnList,
  Url_GetErp6SnNum,
  Url_DelErp6Sn,
  ////////////// 20240604 新增管理->库存管理
  //入库管理
  Url_AddErp6InventoryIn,
  Url_DelErp6InventoryIn,
  Url_EditErp6InventoryIn,
  Url_GetErp6InventoryInNum,
  Url_GetErp6InventoryInList,
  //出库管理
  Url_AddErp6InventoryOut,
  Url_DelErp6InventoryOut,
  Url_EditErp6InventoryOut,
  Url_GetErp6InventoryOutNum,
  Url_GetErp6InventoryOutList,
  Url_GetErp6InventoryRealTimeNum,
  Url_GetErp6InventoryRealTimeList,
  //库存明细
  Url_GetErp6InventoryMonthlyList,
  Url_GetErp6InventoryMonthlyNum,
  Url_GetErp6InventoryDetailsList,
  Url_GetErp6InventoryDetailsNum,
  //库存管理看板
  Url_Erp6InventorySignboard,
  //20240518 后台视光分析
  //基本信息
  Url_AddErp7ShiGuangJiBenXinXi,
  Url_EditErp7ShiGuangJiBenXinXi,
  Url_DelErp7ShiGuangJiBenXinXi,
  Url_GetErp7ShiGuangJiBenXinXiList,
  Url_GetErp7ShiGuangJiBenXinXiNum,
  //验光检查档案
  Url_AddErp7ShiGuangYanGuangJianCha,
  Url_EditErp7ShiGuangYanGuangJianCha,
  Url_DelErp7ShiGuangYanGuangJianCha,
  Url_GetErp7ShiGuangYanGuangJianChaList,
  Url_GetErp7ShiGuangYanGuangJianChaList2,
  Url_GetErp7ShiGuangYanGuangJianChaNum,
  Url_GetErp7ShiGuangYanGuangJianChaSingle,
  //验光检查档案
  Url_AddErp7ShiGuangTiaoJieGongNeng,
  Url_EditErp7ShiGuangTiaoJieGongNeng,
  Url_DelErp7ShiGuangTiaoJieGongNeng,
  Url_GetErp7ShiGuangTiaoJieGongNengList,
  Url_GetErp7ShiGuangTiaoJieGongNengNum,
  //眼健康评估曲线图
  Url_AddErp7ShiGuangYanJianKangQuXian,
  Url_EditErp7ShiGuangYanJianKangQuXian,
  Url_DelErp7ShiGuangYanJianKangQuXian,
  Url_GetErp7ShiGuangYanJianKangQuXianList,
  Url_GetErp7ShiGuangYanJianKangQuXianNum,
  //训练平板-ERP
  Url_AddTrainPadGameSort,
  Url_EditTrainPadGameSort,
  Url_DeleteTrainPadGameSort,
  Url_GetTrainPadGameSortlist,
  Url_AddTrainPadGameList,
  Url_EditTrainPadGameList,
  Url_DeleteTrainPadGameList,
  Url_GetTrainPadGameList,
  Url_GetTrainPadLogList,
  Url_GetTrainPadLogNum,
  Url_GetTrainPadClickList,
  Url_GetTrainPadClickNum,
  Url_GetTrainPadDayTongJiList,
  Url_GetTrainPadDayTongJiNum,
  //屈光参差变焦镜-设备管理
  Url_AddRefractiveDiscrepancyDevice,
  Url_EditRefractiveDiscrepancyDevice,
  Url_GetRefractiveDiscrepancyDeviceList,
  Url_GetRefractiveDiscrepancyDeviceNum,
  //屈光参差变焦镜-用户管理
  Url_AddRefractiveDiscrepancyUser,
  Url_EditRefractiveDiscrepancyUser,
  Url_GetRefractiveDiscrepancyUserList,
  Url_GetRefractiveDiscrepancyUserNum,
  //屈光参差变焦镜-用户复查管理
  Url_AddRefractiveDiscrepancyUserFuCha,
  Url_EditRefractiveDiscrepancyUserFuCha,
  Url_GetRefractiveDiscrepancyUserFuChaList,
  Url_GetRefractiveDiscrepancyUserFuChaNum,
  //视力变化趋势图 H5
  Url_AnisoFocusListVisionTrend,
  //豆迈科技-眼镜用户管理
  Url_DouMaiKeJiGlassuserGetList,
  Url_DouMaiKeJiGlassuserGetNum,
  Url_DouMaiKeJiGlassuserNewSn,
  Url_DouMaiKeJiGlassuserAdd,
  Url_DouMaiKeJiGlassuserUnbind,
  Url_DouMaiKeJiGlassuserOldSnGetList,
  Url_DouMaiKeJiWxUserGetList,
  Url_DouMaiKeJiWxUserGetNum,
  Url_DouMaiKeJiWxUserChangeYeWuYuan,
  //豆迈科技-用户复查管理
  Url_AddMiniProgramDouMaiKeJiUserFuCha,
  Url_EditMiniProgramDouMaiKeJiUserFuCha,
  Url_GetMiniProgramDouMaiKeJiUserFuChaList,
  Url_GetMiniProgramDouMaiKeJiUserFuChaNum,
  //豆迈科技-一周佩戴时长 H5
  Url_DouMaiKeJiShiChangTuBiao,
  //门店进销存管理
  //采购管理
  Url_AddMenDianPurchaseSalesJinXiao,
  Url_DeleteMenDianPurchaseSalesJinXiao,
  Url_EditMenDianPurchaseSalesJinXiao,
  Url_GetMenDianPurchaseSalesJinXiaoList,
  Url_GetMenDianPurchaseSalesJinXiaoNum,
  //库存管理
  Url_MenDianPurchaseSalesKuCun,
  Url_MenDianPurchaseSalesKuCunNum,
  //领用出库
  Url_AddMenDianPurchaseSalesKuCunOutUse,
  Url_DeleteMenDianPurchaseSalesKuCunOutUse,
  Url_GetMenDianPurchaseSalesKuCunOutUseList,
  //销售出库
  Url_AddMenDianPurchaseSalesKuCunOutSale,
  Url_DeleteMenDianPurchaseSalesKuCunOutSale,
  Url_GetMenDianPurchaseSalesKuCunOutSaleList,
  //采购汇总
  Url_MenDianPurchaseSalesCaiGouHuiZong,
  //销售汇总
  Url_MenDianPurchaseSalesXiaoShouHuiZong,
  //费用录入
  Url_AddMenDianPurchaseSalesFeiYongLuRu,
  Url_DeleteMenDianPurchaseSalesFeiYongLuRu,
  Url_EditMenDianPurchaseSalesFeiYongLuRu,
  Url_GetMenDianPurchaseSalesFeiYongLuRuList,
  Url_GetMenDianPurchaseSalesFeiYongLuRuNum,
  //鹰瞳-眼底照相机
  Url_GetYingTongDeviceList,
  Url_GetYingTongDeviceNum,
  Url_GetYingTongReportList,
  Url_GetYingTongReportNum,
  // 全局变量
  Gv_FromName,
  Gv_FromLogo
}

Vue.prototype.FunLogInfo = function (info){
  console.log(info)
};

Vue.prototype.FunLogError = function (error){
  console.log(error)
};

Vue.prototype.FunGetLocalFingerprint = function (){
  return getBrowserFingerprint();
};

Vue.prototype.FunGetSignErp = function (data){
  var newData = {};
  Object.keys(data).sort().map(key => {
    var databuf = String(data[key])
    if(databuf.length > 0 && databuf != '0' && databuf != 'null')
    {
      newData[key] = databuf.replace(/ /g,"")
    }
  })
  newData['authtokenerp'] = localStorage.getItem('Authtokenerp')
  var str = Qs.stringify(newData)
  // console.log(str)
  str = md5(str)
  // console.log(str)
  str = md5(str)
  // console.log(str)
  return str.toUpperCase()
};

Vue.prototype.FunGetSignRslEv = function (data){
  var newData = {};
  Object.keys(data).sort().map(key => {
    var databuf = String(data[key])
    if(databuf.length > 0 && databuf != '0' && databuf != 'null')
    {
      newData[key] = databuf.replace(/ /g,"")
    }
  })
  newData['authtokenerp'] = localStorage.getItem('Authtokenrslev')
  var str = Qs.stringify(newData)
  // console.log(str)
  str = md5(str)
  // console.log(str)
  str = md5(str)
  // console.log(str)
  return str.toUpperCase()
};

/**
* 验证数据 是数字：返回true；不是数字：返回false
**/
Vue.prototype.FunCheckNumber = function (val) {
　　if (parseFloat(val).toString() == "NaN") {
　　　　return false;
　　} else {
　　　　return true;
　　}
}

//弹框提醒
Vue.prototype.FunAlertMsg = function (msg) {
  Vue.prototype.$alert(msg, '提示', {
    confirmButtonText: '确定',
    callback: action => {
    }
  });
};

//始终提醒接口的操作结果
Vue.prototype.FunCheckApiCode = function (data) {
  if(data.Code < 200) {
    Vue.prototype.QuitErp(data.Errormsg)
  } else {
    Vue.prototype.$alert(data.Errormsg, '提示', {
      confirmButtonText: '确定',
      callback: action => {
      }
    });
  }
};

//接口出现异常才提醒
Vue.prototype.FunCheckApiCodeBackground = function (data) {
  if(data.Code != 200){
    if(data.Code < 200) {
      Vue.prototype.QuitErp(data.Errormsg)
    } else {
      Vue.prototype.$alert(data.Errormsg, '提示', {
        confirmButtonText: '确定',
        callback: action => {
        }
      });
    }
  }
};

// alertstatus true,始终提醒;false,代表只有出错时才提醒
Vue.prototype.FunCheckApiCodeWithCallback = function (data,alertstatus,mycallback) {
  if((!alertstatus && data.Code != 200) || alertstatus) {
    if(data.Code < 200) {
      Vue.prototype.QuitErp(data.Errormsg)
    } else {
      Vue.prototype.$alert(data.Errormsg, '提示', {
        confirmButtonText: '确定',
        callback: action => {
          if(data.Code == 200){
            mycallback()
          }
        }
      });
    }
  }
};

Vue.prototype.QuitErp = function (msg) {
  Vue.prototype.$notify.error({
    title: '错误',
    message: msg,
    duration: 5000
  });

  if(Url_Base.indexOf("apirsl.eyesreal.com") != -1){
    //清空数据
    localStorage.setItem('Useriderp', '')
    localStorage.setItem('Nicename', '')
    localStorage.setItem('Authtokenerp', '')
    localStorage.setItem('LocalFingerprint', '')
    //跳转
    router.push('/Login')
  }
}

Vue.prototype.QuitRslEv = function () {
    //清空数据
    localStorage.setItem('Useriderp', '')
    localStorage.setItem('Roletype', '')
    localStorage.setItem('Authtokenrslev', '')
    localStorage.setItem('LocalFingerprint', '')
    //跳转
    router.push('/RslEvLoginView')
}

Vue.prototype.CheckRslEvKeyWord = function () {
  var isok = false
  var ua = ""

  if(typeof(window.external.GetKeyWord) !== 'undefined'){
    ua = window.external.GetKeyWord()
  }

  if(ua != 'ChangJieRSLEVBrowser:RSL-EV V1.0'){
    isok = false
  } else {
    isok = true
  }
  if(!isok){
    //清空数据
    localStorage.setItem('Useriderp', '')
    localStorage.setItem('Roletype', '')
    localStorage.setItem('Authtokenrslev', '')
    localStorage.setItem('LocalFingerprint', '')
    //跳转
    router.push('/RslErrorView')
  }
}

//UUID
Vue.prototype.FunGetUUID = function () {
  function S4() {
  		return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  	}
  	return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
};

//双倍UUID
Vue.prototype.FunGetUUIDDouble = function () {
  	return Vue.prototype.FunGetUUID() + Vue.prototype.FunGetUUID();
};

//校验当前用户是否有权限
Vue.prototype.FunCheckSubRule = function (nameen,callback) {
  var useriderp = localStorage.getItem('Useriderp')
  var timestamp = Date.parse(new Date())/1000
  var data = {
    os: 'erp',
    useriderp: useriderp,
    timestamp:timestamp,
    localfingerprint:Vue.prototype.FunGetLocalFingerprint(),
    rulename:nameen
  }
  //加上签名
  data['sign'] = Vue.prototype.FunGetSignErp(data)
  axios.post(Vue.prototype.global.Url_GetSubRuleStaus, Qs.stringify(data))
    .then(function (response) {
      callback(response)
    })
    .catch(function (error) {
      Vue.prototype.FunLogError(error)
    })
}

//获取当前时间格式化字符串
Vue.prototype.FunGetTimeStringShort = function () {
  var today = new Date();
  var month = today.getMonth() + 1;
  month = month < 10 ? '0'+month : month;
  var day = today.getDate() < 10 ? '0'+today.getDate() : today.getDate();
  var now = today.getFullYear() + '-' + month + '-' + day;
  return now;
}

//获取当前时间格式化字符串
Vue.prototype.FunGetTimeStringShortFirst = function () {
  var today = new Date();
  var month = today.getMonth() + 1;
  month = month < 10 ? '0'+month : month;
  var now = today.getFullYear() + '-' + month + '-01';
  return now;
}

//获取当前时间格式化字符串-年
Vue.prototype.FunGetTimeStringY = function () {
  var today = new Date();
  var now = today.getFullYear();
  return now;
}

//获取当前时间格式化字符串-年月
Vue.prototype.FunGetTimeStringYM = function () {
  var today = new Date();
  var month = today.getMonth() + 1;
  month = month < 10 ? '0'+month : month;
  var now = today.getFullYear() + '-' + month;
  return now;
}

//获取当前时间格式化字符串
Vue.prototype.FunGetTimeStringLong = function () {
  var today = new Date();
  var month = today.getMonth() + 1;
  month = month < 10 ? '0'+month : month;
  var day = today.getDate() < 10 ? '0'+today.getDate() : today.getDate();
  var hours = today.getHours() < 10 ? '0'+today.getHours() : today.getHours();
  var mins = today.getMinutes() < 10 ? '0'+today.getMinutes() : today.getMinutes();
  var secs = today.getSeconds() < 10 ? '0'+today.getSeconds() : today.getSeconds();
  var now = today.getFullYear() + '-' + month + '-' + day + ' ' + hours + ":" + mins + ":" + secs ;
  return now;
}

// 分割时间字符串
Vue.prototype.SplitTimeString = function (timestring) {
  var str = timestring.split(' ');
  return str[0];
}

function bin2hex(s) {
  var i, l, o = '',n;
  s += '';
  for (i = 0, l = s.length; i < l; i++) {
    n = s.charCodeAt(i)
      .toString(16);
    o += n.length < 2 ? '0' + n : n;
  }
  return o;
}

function getBrowserFingerprint() {
  var LocalFingerprint = localStorage.getItem('LocalFingerprint')
  var needGenerate = false
  if(LocalFingerprint == null){
    needGenerate = true
  } else {
    if(LocalFingerprint.length < 5) {
      needGenerate = true
    }
  }
  if(needGenerate){
    LocalFingerprint = Vue.prototype.FunGetUUID()
    localStorage.setItem('LocalFingerprint',LocalFingerprint)
  }
  return LocalFingerprint
}

Vue.prototype.FunReviewFileurl = function (fileurl,myrouter) {
  // 获取后缀名
  var index = fileurl.lastIndexOf('.')
  var ext = fileurl.substr(index + 1)
  if (ext === 'jpg' || ext === 'png') {
    localStorage.setItem('imagereviewurl', fileurl)
    var routeData = myrouter.resolve({
      path: '/MyViewer',
      name: 'MyViewer'
    })
    window.open(routeData.href, '_blank')
  } else {
    window.open(fileurl, '_blank')
  }
}

Vue.prototype.FunGet2DecimalPlaces = function (num) {
  return Number(Number(num).toFixed(2))
}

Vue.prototype.FunGetShortString = function (v) {
  if(v.length < 9){
    return v;
  }
  return v.substring(0,2) + "..." + v.substring(v.length-3,v.length-1);
}

Vue.prototype.FunGetAdd = function (v) {
  var rv = "0.00D";
  if(v == "0"){
    rv = "0.00D";
  }
  if(v == "1"){
    rv = "0.50D";
  }
  if(v == "2"){
    rv = "0.75D";
  }
  if(v == "3"){
    rv = "1.00D";
  }
  if(v == "4"){
    rv = "1.25D";
  }
  if(v == "5"){
    rv = "1.50D";
  }
  if(v == "6"){
    rv = "1.75D";
  }
  if(v == "7"){
    rv = "2.00D";
  }
  if(v == "8"){
    rv = "2.25D";
  }
  if(v == "9"){
    rv = "2.50D";
  }
  if(v == "10"){
    rv = "2.75D";
  }
  if(v == "11"){
    rv = "3.00D";
  }
  if(v == "12"){
    rv = "3.25D";
  }
  if(v == "13"){
    rv = "3.50D";
  }
  if(v == "14"){
    rv = "3.75D";
  }
  if(v == "15"){
    rv = "4.00D";
  }
  if(v == "16"){
    rv = "4.25D";
  }
  if(v == "17"){
    rv = "4.50D";
  }
  if(v == "18"){
    rv = "4.75D";
  }
  if(v == "19"){
    rv = "5.00D";
  }
  return rv;
}

Vue.prototype.FunGetNewsType = function () {
  var newstype = []
  newstype.push({ value: '0', label: '请选择类型' })
  newstype.push({ value: '1', label: '左上角数据' })
  newstype.push({ value: '2', label: '今日热榜' })
  newstype.push({ value: '3', label: '热点推荐' })
  newstype.push({ value: '4', label: '视力健康' })
  newstype.push({ value: '5', label: '公司要闻' })
  newstype.push({ value: '6', label: '时政热点' })
  newstype.push({ value: '7', label: '人工智能' })
  newstype.push({ value: '8', label: '国际时事' })
  newstype.push({ value: '9', label: '社会公益' })
  newstype.push({ value: '10', label: '睿世力进校园' })
  newstype.push({ value: '11', label: '公益检查' })
  newstype.push({ value: '101', label: '北京睿世力科技有限公司' })
  newstype.push({ value: '102', label: '江苏睿世力科技有限公司' })
  newstype.push({ value: '103', label: '睿世力光学技术(丹阳)有限公司' })
  newstype.push({ value: '104', label: '睿世力眼谷(江苏)科技发展有限公司' })
  newstype.push({ value: '105', label: '睿世力医疗器械(浙江)有限公司' })
  newstype.push({ value: '106', label: '江苏睿世力医疗科技服务有限公司' })
  newstype.push({ value: '107', label: '江苏睿世力销售有限公司' })
  newstype.push({ value: '108', label: '杭州睿世力健康科技有限公司' })
  newstype.push({ value: '109', label: '睿世力科技(上海)有限公司' })
  newstype.push({ value: '110', label: '睿世力光学技术(丹阳)有限公司' })
  newstype.push({ value: '111', label: '山西睿世力科技有限公司' })
  return newstype
}

Vue.prototype.FunGetLearnVideo = function () {
  var learnvideo = []
  learnvideo.push({ value: '0', label: '请选择类型' })
  learnvideo.push({ value: '1', label: '新闻动态左上角数据' })
  learnvideo.push({ value: '2', label: '新闻动态热门视频' })
  learnvideo.push({ value: '3', label: '学习专栏左上角数据' })
  learnvideo.push({ value: '4', label: '学习专栏抖音视频' })
  learnvideo.push({ value: '5', label: '学习专栏今日热榜' })
  learnvideo.push({ value: '6', label: '学习专栏热门视频' })
  learnvideo.push({ value: '7', label: '重磅推荐' })
  learnvideo.push({ value: '8', label: '视力健康' })
  learnvideo.push({ value: '9', label: '知识科普' })
  learnvideo.push({ value: '10', label: '专家讲座' })
  learnvideo.push({ value: '11', label: '人工智能' })
  learnvideo.push({ value: '12', label: '社会公益' })
  learnvideo.push({ value: '13', label: '员工培训' })
  return learnvideo
}

Vue.prototype.FunGetInfoType = function () {
  var infotype = []
  infotype.push({ value: '0', label: '请选择类型' })
  infotype.push({ value: '1', label: '集团简介' })
  infotype.push({ value: '2', label: '企业文化' })
  infotype.push({ value: '3', label: '组织架构' })
  infotype.push({ value: '4', label: '研发团队' })
  infotype.push({ value: '5', label: '战略合作' })
  return infotype
}

Vue.prototype.FunGetHonortype = function () {
  var honortype = []
  honortype.push({ value: '0', label: '请选择类型' })
  honortype.push({ value: '1', label: '所获专利' })
  honortype.push({ value: '2', label: '获奖证书' })
  return honortype
}

Vue.prototype.FunGetTsType = function () {
  var learnvideo = []
  learnvideo.push({ value: '0', label: '请选择类型' })
  learnvideo.push({ value: '1', label: '人才战略' })
  learnvideo.push({ value: '2', label: '人事部' })
  learnvideo.push({ value: '3', label: '财务部' })
  learnvideo.push({ value: '4', label: '设计部' })
  learnvideo.push({ value: '5', label: '企划部' })
  learnvideo.push({ value: '6', label: '研发部' })
  learnvideo.push({ value: '7', label: '客服部' })
  learnvideo.push({ value: '8', label: '运营中心' })
  learnvideo.push({ value: '9', label: '视光技术部' })
  learnvideo.push({ value: '10', label: '战略规划部' })
  return learnvideo
}

Vue.prototype.FunGetAddType = function () {
  var honortype = []
  honortype.push({ value: '0', label: '0.00D' })
  honortype.push({ value: '1', label: '0.50D' })
  honortype.push({ value: '2', label: '0.75D' })
  honortype.push({ value: '3', label: '1.00D' })
  honortype.push({ value: '4', label: '1.25D' })
  honortype.push({ value: '5', label: '1.50D' })
  honortype.push({ value: '6', label: '1.75D' })
  honortype.push({ value: '7', label: '2.00D' })
  honortype.push({ value: '8', label: '2.25D' })
  honortype.push({ value: '9', label: '2.50D' })
  honortype.push({ value: '10', label: '2.75D' })
  honortype.push({ value: '11', label: '3.00D' })
  honortype.push({ value: '12', label: '3.25D' })
  honortype.push({ value: '13', label: '3.50D' })
  honortype.push({ value: '14', label: '3.75D' })
  honortype.push({ value: '15', label: '4.00D' })
  honortype.push({ value: '16', label: '4.25D' })
  honortype.push({ value: '17', label: '4.50D' })
  honortype.push({ value: '18', label: '4.75D' })
  honortype.push({ value: '19', label: '5.00D' })
  return honortype
}

Vue.prototype.FunGetPurchaseCompany = function () {
  var buf = []
  buf.push({ value: '江苏睿世力科技有限公司', label: '江苏睿世力科技有限公司' })
  buf.push({ value: '眼谷（江苏）医疗器械有限公司', label: '眼谷（江苏）医疗器械有限公司' })
  buf.push({ value: '睿世力视力矫正（常州）有限公司', label: '睿世力视力矫正（常州）有限公司' })
  buf.push({ value: '广州睿眼科技有限公司', label: '广州睿眼科技有限公司' })
  buf.push({ value: '北京睿世力科技有限公司', label: '北京睿世力科技有限公司' })
  buf.push({ value: '睿世力科技丹阳有限公司', label: '睿世力科技丹阳有限公司' })
  buf.push({ value: '睿世力医疗器械（浙江）有限公司', label: '睿世力医疗器械（浙江）有限公司' })
  buf.push({ value: '睿世力科技（丹阳）有限公司', label: '睿世力科技（丹阳）有限公司' })
  return buf
}

Vue.prototype.FunGetRuiShiLiYanKeMenDian = function () {
  var buf = []
  buf.push({ value: '-1', label: '请选择门店' })
  buf.push({ value: '12025', label: '睿世力江苏南京秦淮锦创书城服务店' })
  buf.push({ value: '10036', label: '睿世力江苏南京红山耀市服务店' })
  buf.push({ value: '14031', label: '睿世力江苏无锡江阴市服务店' })
  return buf
}

Vue.prototype.FunGetRuiShiLiYanKeMenDianChanPingLeiBie = function () {
  var buf = []
  buf.push({ value: '', label: '请选择类别' })
  buf.push({ value: '产品', label: '产品' })
  buf.push({ value: '辅料', label: '辅料' })
  buf.push({ value: '办公用品', label: '办公用品' })
  buf.push({ value: '固定资产', label: '固定资产' })
  buf.push({ value: '其他', label: '其他' })
  return buf
}

Vue.prototype.FunGetRuiShiLiYanKeMenDianFeiYongLeiBie = function () {
  var buf = []
  buf.push({ value: '-1', label: '请选择费用类别' })
  buf.push({ value: '1', label: '人工费' })
  buf.push({ value: '2', label: '租赁费' })
  buf.push({ value: '3', label: '社保公积金' })
  buf.push({ value: '4', label: '水电费' })
  buf.push({ value: '5', label: '办公费' })
  buf.push({ value: '6', label: '仪器设备折旧费' })
  buf.push({ value: '7', label: '福利费' })
  buf.push({ value: '8', label: '其他费用' })
  return buf
}

//从服务器获取Bomsn
Vue.prototype.FunListBomsn = function (callback) {
  var useriderp = localStorage.getItem('Useriderp')
  var timestamp = Date.parse(new Date())/1000
  var data = {
    os: 'erp',
    useriderp: useriderp,
    timestamp:timestamp,
    localfingerprint:Vue.prototype.FunGetLocalFingerprint()
  }
  //加上签名
  data['sign'] = Vue.prototype.FunGetSignErp(data)
  axios.post(Vue.prototype.global.Url_ListBomsn, Qs.stringify(data))
    .then(function (response) {
      callback(response)
    })
    .catch(function (error) {
      Vue.prototype.FunLogError(error)
    })
}

Vue.prototype.ChangeTwoDecimalF = function (x) {
    var f_x = parseFloat(x);
    if (isNaN(f_x)) {
        alert('function:changeTwoDecimal->parameter error');
        return false;
    }
    var f_x = Math.round(x * 100) / 100;
    var s_x = f_x.toString();
    var pos_decimal = s_x.indexOf('.');
    if (pos_decimal < 0) {
        pos_decimal = s_x.length;
        s_x += '.';
    }
    while (s_x.length <= pos_decimal + 2) {
        s_x += '0';
    }
    return s_x;
}

Vue.prototype.CloneObj = function (obj){
  var newObj = {};

  if (obj instanceof Array) {
    newObj = [];
  }

  for (var key in obj) {
    var val = obj[key];
    //newObj[key] = typeof val === 'object' ? arguments.callee(val) : val; //arguments.callee 在哪一个函数中运行，它就代表哪个函数, 一般用在匿名函数中。
    newObj[key] = typeof val === 'object' ? this.CloneObj(val): val;
  }
  return newObj;
}

Vue.prototype.getFirstDay = function (){
    var y = new Date().getFullYear(); //获取年份
    var m = new Date().getMonth() + 1; //获取月份
    var d = '01'
    m = m < 10 ? '0' + m : m; //月份补 0

    return [y,m,d].join("-")
}

Vue.prototype.getLastDay = function (){
    var y = new Date().getFullYear(); //获取年份
    var m = new Date().getMonth() + 1; //获取月份
    var d = new Date(y, m, 0).getDate(); //获取当月最后一日
    m = m < 10 ? '0' + m : m; //月份补 0
    d = d < 10 ? '0' + d : d; //日数补 0

    return [y,m,d].join("-")
}

Vue.prototype.processBool = function (v){
  if(v == "true"){
    return true;
  } else {
    return false;
  }
}
